import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs/internal/operators";
import { Values } from "../../../values/values";
import { ApiChatService } from "../api-chat/api-chat.service";

@Injectable()
export class EndpointService {
  private URL = Values.SERVER_URL;

  private reqPattern = Values.API_REQ_PATTERN;

  private observable = null;
  //used for caching some backend requests

  // Joan private userInfoResponse = null;

  constructor(private http: HttpClient, private chatApi: ApiChatService) {}

  public getFileFromUrl(url, path) {
    let headers = new HttpHeaders();
    let requestURL =
      this.URL +
      Values.API_RESOURCES.GENERIC +
      this.reqPattern +
      "download-file";
    let body = JSON.stringify({ url, path });
    return this.http
      .post(requestURL, body, { responseType: "blob" })
      .pipe(map((response) => response));
  }

  public getPropertiesPredefinedSelectorsValues(idInmo: number) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.PROPERTIES +
      this.reqPattern +
      Values.PROPERTIES_REQS.GET_PREDEF_INFO_FOR_SELECTORS;

    requestURL += "&idInmo=" + idInmo;

    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getClientsPredefinedSelectorsValues() {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.CLIENTS +
      this.reqPattern +
      Values.CLIENTS_REQS.GET_PREDEF_INFO_FOR_SELECTORS;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public filterClients(idEmpresa, isIndustriales, idUser) {
    let body = JSON.stringify({ idEmpresa, isIndustriales, idUser });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.SEARCH +
      this.reqPattern +
      Values.SEARCH_REQS.FILTER_CLIENTS;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  // Filtra los clientes y los industriales directamente a partir de un encargo asignado
  public filterClientsFromEncargo(idEmpresa, idEncargo, idUser) {
    let body = JSON.stringify({ idEmpresa, idEncargo, idUser });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.SEARCH +
      this.reqPattern +
      Values.SEARCH_REQS.FILTER_CLIENTS_FROM_ENCARGO;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public filterFlats(idEmpresa, idUser, idIdioma) {
    let body = JSON.stringify({ idEmpresa, idUser, idIdioma });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.SEARCH +
      this.reqPattern +
      Values.SEARCH_REQS.FILTER_FLATS;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public filterFlatsColaboration(
    idEmpresa,
    idUser,
    propertyAccessPermissionLevel,
    idProfile,
    forMobile,
    idIdioma
  ) {
    let body = JSON.stringify({
      idEmpresa,
      idUser,
      propertyAccessPermissionLevel,
      idProfile,
      forMobile,
      idIdioma,
    });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.SEARCH +
      this.reqPattern +
      Values.SEARCH_REQS.FILTER_FLATS_COLABORATION;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public filterEncargos(idEmpresa, idUser) {
    let body = JSON.stringify({ idEmpresa, idUser });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.SEARCH +
      this.reqPattern +
      Values.SEARCH_REQS.FILTER_ENCARGOS;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  ////////////////////////////////PRIVILEGIES//////////////////////////////////
  public getRoles(idInmo) {
    let idInmoParam = "&idInmo=";

    let requestURL =
      this.URL +
      Values.API_RESOURCES.PRIVILEGIES +
      this.reqPattern +
      Values.PRIVILEGIES_REQS.GET_ROLES;

    requestURL += idInmoParam + idInmo;

    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getUserPermissions(idUser: number) {
    let idUserParam = "&idUser=";
    let requestURL =
      this.URL +
      Values.API_RESOURCES.PRIVILEGIES +
      this.reqPattern +
      Values.PRIVILEGIES_REQS.GET_USER_PERMISSIONS;
    requestURL += idUserParam + idUser;
    let options = this.getNoCacheOptions();
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  ////////////////////////////////////////////////////////////////////////////////

  public changeInmoImage(idInmo, file, formData, idImg) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.INMO +
      this.reqPattern +
      Values.INMO_REQS.CHANGE_INMO_IMAGE_URL;
    requestURL += "&idInmo=" + idInmo + "&idImg=" + idImg;

    const headers = new HttpHeaders();

    headers.append("Content-Type", "multipart/form-data");
    headers.append("Accept", "application/json");
    //let options = new RequestOptions({ headers: headers });

    return this.http
      .post(requestURL, formData, { headers })
      .pipe(map((response) => response));
  }

  public uploadAvatarImage(idUser, file, formData, idInmo) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.INMO +
      this.reqPattern +
      Values.INMO_REQS.POST_AVATAR_IMAGE_URL;
    requestURL += "&idUser=" + idUser + "&idInmo=" + idInmo;

    const headers = new HttpHeaders();

    headers.append("Content-Type", "multipart/form-data");
    headers.append("Accept", "application/json");
    //let options = new RequestOptions({ headers: headers });

    return this.http
      .post(requestURL, formData, { headers })
      .pipe(map((response) => response));
  }

  public getAllFromInmoById(idInmo: number) {
    let idInmoParam = "&idInmo=";
    let requestURL =
      this.URL +
      Values.API_RESOURCES.INMO +
      this.reqPattern +
      Values.INMO_REQS.GET_ALL_FROM_INMO_BY_ID;
    requestURL += idInmoParam + idInmo;
    let options = this.getNoCacheOptions();
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getProfiles(idInmo) {
    let body = JSON.stringify({ idInmo });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.INMO +
      this.reqPattern +
      Values.INMO_REQS.GET_PROFILE;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public checkIfDuplicarVivienda(idProperty: number, idInmo: number) {
    let body = JSON.stringify({ idProperty, idInmo });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.PROPERTIES +
      this.reqPattern +
      Values.PROPERTIES_REQS.DUPLICATE_PROPERTY;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getAllFullNamesAndIds(idEmpresa: number) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.CLIENTS +
      this.reqPattern +
      Values.CLIENTS_REQS.GET_ALL_FULL_NAMES_AND_IDS;
    requestURL += "&idEmpresa=" + idEmpresa;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public loginUser(user: string, password: string) {
    let body = JSON.stringify({ user: user, password: password });
    // let requestOptions = this.getRequestOptions();
    let requestURL = this.URL + Values.API_RESOURCES.LOGIN;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public validateUser(user: string) {
    let body = JSON.stringify({ user: user });
    // let requestOptions = this.getRequestOptions();
    let requestURL = this.URL + Values.API_RESOURCES.VALIDTE_USER;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public uploadUserProfilePicture(formData, idUser, nameImage) {
    const headers = new HttpHeaders();

    let requestURL =
      this.URL +
      Values.API_RESOURCES.USER +
      this.reqPattern +
      Values.USER_REQS.UPLOAD_USER_PROFILE_PICTURE;

    requestURL += "&idUser=" + idUser;
    requestURL += "&nameImage=" + nameImage;

    //return this.http.post(requestURL, formData, { headers }).pipe(map(response => response));

    return this.http.post<any>(requestURL, formData, {
      reportProgress: true,
      observe: "events",
    });
  }

  public getAllUsers(idInmo: number, idUser: number) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.INMO +
      this.reqPattern +
      Values.INMO_REQS.GET_ALL_USERS;
    requestURL += "&idInmo=" + idInmo;
    requestURL += "&idUser=" + idUser;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public deleteUser(idUser: number) {
    let body = JSON.stringify({ idUser });
    // Joan let requestOptions = this.getRequestOptions();
    let requestURL =
      this.URL +
      Values.API_RESOURCES.INMO +
      this.reqPattern +
      Values.INMO_REQS.DELETE_USER;

    return this.http.post(requestURL, body).pipe(
      map((response) => {
        this.chatApi.removeUserFromAllGroups(body);

        return response;
      })
    );
  }

  public getUsers(idInmo: number) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.USER +
      this.reqPattern +
      Values.USER_REQS.GET_USERS;
    requestURL += "&idInmo=" + idInmo;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getUser(idUser: number) {
    //can be string, when more than 1
    let idUserParam = "&idUser=";
    let requestURL =
      this.URL +
      Values.API_RESOURCES.USER +
      this.reqPattern +
      Values.USER_REQS.GET_USER;
    requestURL += idUserParam + idUser;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getAllFromUser(idUser: number) {
    //can be string, when more than 1
    let idUserParam = "&idUser=";
    let requestURL =
      this.URL +
      Values.API_RESOURCES.USER +
      this.reqPattern +
      Values.USER_REQS.GET_ALL_FROM_USER;
    requestURL += idUserParam + idUser;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public sendEmailInmueble(values, userId, idCompany) {
    let body = JSON.stringify({ values, userId, idCompany });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.GENERIC +
      this.reqPattern +
      Values.GENERIC_REQUEST.SEND_EMAIL_INMUEBLE;

    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public updateConditionsCustom(conditions) {
    let body = JSON.stringify({ conditions });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.GENERIC +
      this.reqPattern +
      Values.GENERIC_REQUEST.UPDATE_CONDITIONS;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public reloadQueries(allData) {
    let body = JSON.stringify({ allData });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.GENERIC +
      this.reqPattern +
      Values.GENERIC_REQUEST.RELOAD_QUERIES;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public updatePlantillaElementsCustom(elementsPlantilla, subjects, infoPlantilla) {
    let body = JSON.stringify({ elementsPlantilla, subjects, infoPlantilla });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.GENERIC +
      this.reqPattern +
      Values.GENERIC_REQUEST.UPDATE_ELEMENTS_PLANTILLA;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public insertEmailReuseElement(structure, elementsPlantilla, subjects) {
    let body = JSON.stringify({ structure, elementsPlantilla, subjects });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.GENERIC +
      this.reqPattern +
      Values.GENERIC_REQUEST.INSERT_EMAIL_ELEMENTS_REUSE;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public insertUpdateUser(idInmo: number, idUser: number, bodyUser) {
    let body = JSON.stringify({ idInmo, idUser, bodyUser });
    let requestOptions = this.getRequestOptions();
    let requestURL =
      this.URL +
      Values.API_RESOURCES.USER +
      this.reqPattern +
      Values.USER_REQS.INSERT_USER;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public updateProfileUser(idUser, bodyUser) {
    const body = JSON.stringify({ idUser, bodyUser });
    const requestOptions = this.getRequestOptions();
    const requestURL =
      this.URL +
      Values.API_RESOURCES.USER +
      this.reqPattern +
      Values.USER_REQS.UPDATE_PROFILE_USER;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public updateAgendaSettings(idUser, bodyUser, startDay) {
    const body = JSON.stringify({ idUser, bodyUser, startDay });
    const requestOptions = this.getRequestOptions();
    const requestURL =
      this.URL +
      Values.API_RESOURCES.USER +
      this.reqPattern +
      Values.USER_REQS.UPDATE_AGENDA_SETTINGS;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public updateMatchingPassword(email, passwordSimple) {
    const body = JSON.stringify({ email, passwordSimple });
    const requestOptions = this.getRequestOptions();
    const requestURL =
      this.URL +
      Values.API_RESOURCES.USER +
      this.reqPattern +
      Values.USER_REQS.UPDATE_MATCHING_PASSWORD;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public migrateClients(previousUser, newUser) {
    let body = JSON.stringify({ previousUser: previousUser, newUser: newUser });
    let requestOptions = this.getRequestOptions();
    let requestURL =
      this.URL +
      Values.API_RESOURCES.USER +
      this.reqPattern +
      Values.USER_REQS.MIGRATE_CLIENTS;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public removeUser(idUserDel: number, idUserRepl: number) {
    let body = JSON.stringify({ idUserDel, idUserRepl });
    let requestOptions = this.getRequestOptions();
    let requestURL =
      this.URL +
      Values.API_RESOURCES.USER +
      this.reqPattern +
      Values.USER_REQS.REMOVE_USER;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public insertUserReport(idUser, year) {
    let body = JSON.stringify({ idUser: idUser, year: year });
    let requestOptions = this.getRequestOptions();
    let requestURL =
      this.URL +
      Values.API_RESOURCES.USER +
      this.reqPattern +
      Values.USER_REQS.INSERT_USER_REPORT;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  // public updateUserReportValues(userReportValues: Array<ReportObjectChanged>) {
  // 	let body = JSON.stringify({ 'userReportValues': userReportValues });
  // 	let requestOptions = this.getRequestOptions();
  // 	let requestURL = this.URL + Values.API_RESOURCES.USER + this.reqPattern + Values.USER_REQS.UPDATE_USER_REPORT_VALUES;
  // 	return this.http.post(requestURL, body).pipe(map(response => response));
  // }

  // public updateUserReportComission(comission: Array<ComissionChanged>) {
  // 	let body = JSON.stringify({ 'comission': comission });
  // 	let requestOptions = this.getRequestOptions();
  // 	let requestURL = this.URL + Values.API_RESOURCES.USER + this.reqPattern + Values.USER_REQS.UPDATE_USER_REPORT_COMISSION;
  // 	return this.http.post(requestURL, body).pipe(map(response => response));
  // }

  public getUserReports(idUser) {
    const idUserParam = "&idUser=";
    let requestURL =
      this.URL +
      Values.API_RESOURCES.USER +
      this.reqPattern +
      Values.USER_REQS.GET_USER_REPORTS;
    requestURL += idUserParam + idUser;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getUserInfo(token: number) {
    let tokenParam = "&usT=";
    let requestURL =
      this.URL +
      Values.API_RESOURCES.USER +
      this.reqPattern +
      Values.USER_REQS.GET_USER_INFO;
    requestURL += tokenParam + token;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public sendMailToRecoverPassword(email: string) {
    let body = JSON.stringify({ email: email });
    // Joan: No es fa servir // let requestOptions = this.getRequestOptions();
    let requestURL = this.URL + Values.API_RESOURCES.RECOVER_PASSWORD;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public checkCode(user: string, hashKey: string) {
    let body = JSON.stringify({ user: user, hashKey: hashKey });
    // Joan: No es fa servir // let requestOptions = this.getRequestOptions();
    let requestURL = this.URL + Values.API_RESOURCES.CHECK_CODE;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public setNewPassword(user: string, newPassword: string) {
    let body = JSON.stringify({ user: user, newPassword: newPassword });
    // Joan: No es fa servir // let requestOptions = this.getRequestOptions();
    let requestURL = this.URL + Values.API_RESOURCES.CHANGE_PASSWORD;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getAllPropertiesReferencesAndIds(idEmpresa: number) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.PROPERTIES +
      this.reqPattern +
      Values.PROPERTIES_REQS.GET_ALL_PROPERTIES_REFERENCES_AND_IDS;
    requestURL += "&idEmpresa=" + idEmpresa;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  /**
   *
   * Activites Part
   *
   */

  public getActivitiesPrefefinedValues(appModule, id) {
    const idParam = "&module=";
    const reqParam = appModule;
    const idValue = "&id=";
    const reqParam2 = id;
    let requestURL: any;
    requestURL =
      this.URL +
      Values.API_RESOURCES.ACTIVITIES +
      this.reqPattern +
      Values.ACTIVITIES_REQS.GET_ACTIVITIESPREDEFINEDVALUES;
    requestURL += idParam + reqParam;
    requestURL += idValue + reqParam2;

    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public deleteActivity(idAct, cancelMotive) {
    const idParam = "&idAct=";
    const reqParam = idAct;
    let requestURL: any;

    requestURL =
      this.URL +
      Values.API_RESOURCES.ACTIVITIES +
      this.reqPattern +
      Values.ACTIVITIES_REQS.DELETE_ACTIVITY;
    requestURL += idParam + reqParam;

    let body = JSON.stringify({ cancelMotive, idAct });

    let requestOptions = this.getRequestOptions();

    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public signActivity(
    idAct,
    signLike,
    signNotify,
    signDNI,
    signImgURL,
    signObservation
  ) {
    const idParam = "&idAct=";
    const reqParam = idAct;
    let requestURL: any;

    requestURL =
      this.URL +
      Values.API_RESOURCES.ACTIVITIES +
      this.reqPattern +
      Values.ACTIVITIES_REQS.SIGN_ACTIVITY;
    requestURL += idParam + reqParam;

    let body = JSON.stringify({
      signLike: signLike,
      signNotify: signNotify,
      signDNI: signDNI,
      signImgURL: signImgURL,
      signObservation: signObservation,
    });

    let requestOptions = this.getRequestOptions();

    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getCategories(id, accountId, accountType, isOrphan) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.ACTIVITIES +
      this.reqPattern +
      Values.ACTIVITIES_REQS.GET_CATEGORIES;
    let body = JSON.stringify({ id, accountId, accountType, isOrphan });
    let requestOptions = this.getRequestOptions();
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }
  public addNewCategoryType(
    calendarCategory,
    idProfile,
    accountId,
    accountType
  ) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.ACTIVITIES +
      this.reqPattern +
      Values.ACTIVITIES_REQS.ADD_NEW_CATEGORY_TYPE;
    let body = JSON.stringify({
      idProfile,
      calendarCategory,
      accountId,
      accountType,
    });
    let requestOptions = this.getRequestOptions();
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public updateCategoryType(calendarCategory, idProfile, idType) {
    const idValue = "&idProfile=";
    const reqParam = idProfile;
    const idValue2 = "&idType=";
    const reqParam2 = idType;
    let requestURL =
      this.URL +
      Values.API_RESOURCES.ACTIVITIES +
      this.reqPattern +
      Values.ACTIVITIES_REQS.UPDATE_CATEGORY_TYPE;
    requestURL += idValue + reqParam;
    requestURL += idValue2 + reqParam2;

    let body = JSON.stringify({ calendarCategory });
    //let requestOptions = this.getRequestOptions();
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public deleteCategoryType(idProfile, idType) {
    const idValue = "&idProfile=";
    const reqParam = idProfile;
    const idValue2 = "&idType=";
    const reqParam2 = idType;
    let requestURL =
      this.URL +
      Values.API_RESOURCES.ACTIVITIES +
      this.reqPattern +
      Values.ACTIVITIES_REQS.DELETE_CATEGORY_TYPE;
    requestURL += idValue + reqParam;
    requestURL += idValue2 + reqParam2;
    return this.http.post(requestURL, null).pipe(map((response) => response));
  }

  public getCalendarActivities(
    idEmpresa,
    idUser: number,
    elementsToFilter,
    dateFilter,
    showShareCalendar
  ) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.ACTIVITIES +
      this.reqPattern +
      Values.ACTIVITIES_REQS.GET_CALENDAR_ACTIVITIES;
    requestURL += "&idEmpresa=" + idEmpresa;
    requestURL += "&idUser=" + idUser;
    const body = JSON.stringify({
      elementsToFilter,
      dateFilter,
      showShareCalendar,
    });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getCalendarOneActivity(id: number, idUser: number) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.ACTIVITIES +
      this.reqPattern +
      Values.ACTIVITIES_REQS.GET_ONEACTIVITIY;
    requestURL += "&id=" + id;
    requestURL += "&idUser=" + idUser;
    return this.http.post(requestURL, null).pipe(map((response) => response));
  }

  public getCalendarActivitiesByCategories(idUser: number, category: number) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.ACTIVITIES +
      this.reqPattern +
      Values.ACTIVITIES_REQS.GET_CALENDAR_ACTIVITIES_BY_CATEGORY;
    requestURL += "&idUser=" + idUser;
    requestURL += "&category=" + category;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public addNewCalendarActivity(calendarEvent) {
    let requestURL: any;
    requestURL =
      this.URL +
      Values.API_RESOURCES.ACTIVITIES +
      this.reqPattern +
      Values.ACTIVITIES_REQS.ADD_NEW_CALENDAR_ACTIVITY;
    let body = JSON.stringify({ calendarEvent });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public addNewCalendarPeriodActivities(calendarEvents) {
    let requestURL: any;
    requestURL =
      this.URL +
      Values.API_RESOURCES.ACTIVITIES +
      this.reqPattern +
      Values.ACTIVITIES_REQS.ADD_NEW_CALENDAR_PERIOD_ACTIVITIES;
    let body = JSON.stringify({ calendarEvents });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public deleteCalendarActivity(idActivity) {
    const nameValue = "&idActivity=";
    const reqParam1 = idActivity;
    let requestURL =
      this.URL +
      Values.API_RESOURCES.ACTIVITIES +
      this.reqPattern +
      Values.ACTIVITIES_REQS.DELETE_CALENDAR_ACTIVITY;
    requestURL += nameValue + reqParam1;
    return this.http.post(requestURL, null).pipe(map((response) => response));
  }

  public deletePeriodCalendarActivity(event) {
    let requestURL: any;
    requestURL =
      this.URL +
      Values.API_RESOURCES.ACTIVITIES +
      this.reqPattern +
      Values.ACTIVITIES_REQS.DELETE_CALENDAR_PERIOD_ACTIVITY;
    let body = JSON.stringify({ event });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public updateCalendarActivity(calendarEvent, idActivity) {
    const nameValue = "&idActivity=";
    const reqParam1 = idActivity;
    let requestURL =
      this.URL +
      Values.API_RESOURCES.ACTIVITIES +
      this.reqPattern +
      Values.ACTIVITIES_REQS.UPDATE_CALENDAR_ACTIVITY;

    requestURL += nameValue + reqParam1;
    let body = JSON.stringify({ calendarEvent });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public updatePeriodicCalendarActivity(calendarEvent, event) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.ACTIVITIES +
      this.reqPattern +
      Values.ACTIVITIES_REQS.UPDATE_PERIODIC_CALENDAR_ACTIVITY;
    let body = JSON.stringify({ calendarEvent, event });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public updateCalendarActivityCategory(
    newActivityCategory,
    oldActivityCategory
  ) {
    const nameValue = "&newActivityCategory=";
    const reqParam1 = newActivityCategory;
    const nameValue2 = "&oldActivityCategory=";
    const reqParam2 = oldActivityCategory;
    let requestURL =
      this.URL +
      Values.API_RESOURCES.ACTIVITIES +
      this.reqPattern +
      Values.ACTIVITIES_REQS.UPDATE_CALENDAR_ACTIVITY_CATEGORY;

    requestURL += nameValue + reqParam1;
    requestURL += nameValue2 + reqParam2;
    return this.http.post(requestURL, null).pipe(map((response) => response));
  }

  /************************
   *
   *
   * Eventos
   *
   *
   *************************/

  /************************
   *
   *
   * Templates emails/pdf
   *
   *
   *************************/

  public getFilesForAttachment() {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.EMAILTEMPLATES +
      this.reqPattern +
      Values.EMAILTEMPLATES_REQS.GET_FILES_FOR_ATTACHMENT;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getAllTemplates() {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.EMAILTEMPLATES +
      this.reqPattern +
      Values.EMAILTEMPLATES_REQS.GET_ALL_TEMPLATES;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getAllTemplatesByType(idTipo) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.EMAILTEMPLATES +
      this.reqPattern +
      Values.EMAILTEMPLATES_REQS.GET_ALL_TEMPLATES_BY_TYPE;
    let body = JSON.stringify({ idTipo });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getAllTemplatesPdf() {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.EMAILTEMPLATES +
      this.reqPattern +
      Values.EMAILTEMPLATES_REQS.GET_ALL_TEMPLATES_PDF;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getAllTemplatesNames(idInmo) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.EMAILTEMPLATES +
      this.reqPattern +
      Values.EMAILTEMPLATES_REQS.GET_ALL_TEMPLATES_NAMES;
    requestURL += "&idInmo=" + idInmo;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getAllTemplatesNamesByModule(idInmo, modPrim) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.EMAILTEMPLATES +
      this.reqPattern +
      Values.EMAILTEMPLATES_REQS.GET_ALL_TEMPLATES_NAMES_BY_MODULE;
    requestURL += "&idInmo=" + idInmo;
    requestURL += "&modPrim=" + modPrim;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getAllEmailImages(idInmo) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.EMAILTEMPLATES +
      this.reqPattern +
      Values.EMAILTEMPLATES_REQS.GET_ALL_EMAIL_IMAGES;
    requestURL += "&idInmo=" + idInmo;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getAllEgoImages() {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.EGO_NOTIFICATIONS +
      this.reqPattern +
      Values.EGONOTIFICATIONS_REQS.GET_ALL_EGO_IMAGES;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getTemplate(templateID) {
    const idParam = "&templateID=";
    const reqParam = templateID;

    let requestURL: any;
    requestURL =
      this.URL +
      Values.API_RESOURCES.EMAILTEMPLATES +
      this.reqPattern +
      Values.EMAILTEMPLATES_REQS.GET_TEMPLATE;
    requestURL += idParam + reqParam;

    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getTemplatePdf(templateID) {
    const idParam = "&templateID=";
    const reqParam = templateID;

    let requestURL: any;
    requestURL =
      this.URL +
      Values.API_RESOURCES.EMAILTEMPLATES +
      this.reqPattern +
      Values.EMAILTEMPLATES_REQS.GET_TEMPLATE_PDF;
    requestURL += idParam + reqParam;

    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public insertTemplate(template, idInmo) {
    let requestURL: any;

    requestURL =
      this.URL +
      Values.API_RESOURCES.EMAILTEMPLATES +
      this.reqPattern +
      Values.EMAILTEMPLATES_REQS.INSERT_TEMPLATE;

    let body = JSON.stringify({ template: template, idInmo: idInmo });

    let requestOptions = this.getRequestOptions();

    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public updateTemplate(template) {
    let requestURL: any;
    requestURL =
      this.URL +
      Values.API_RESOURCES.EMAILTEMPLATES +
      this.reqPattern +
      Values.EMAILTEMPLATES_REQS.UPDATE_TEMPLATE;

    let body = JSON.stringify({ template });

    let requestOptions = this.getRequestOptions();

    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public deleteTemplate(templateId) {
    let requestURL: any;
    requestURL =
      this.URL +
      Values.API_RESOURCES.EMAILTEMPLATES +
      this.reqPattern +
      Values.EMAILTEMPLATES_REQS.DELETE_TEMPLATE;

    let body = JSON.stringify({ templateId });

    let requestOptions = this.getRequestOptions();

    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public insertTemplatePdf(template, idInmo) {
    let requestURL: any;

    requestURL =
      this.URL +
      Values.API_RESOURCES.EMAILTEMPLATES +
      this.reqPattern +
      Values.EMAILTEMPLATES_REQS.INSERT_TEMPLATE_PDF;

    let body = JSON.stringify({ template, idInmo: idInmo });

    let requestOptions = this.getRequestOptions();

    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public updateTemplatePdf(template) {
    let requestURL: any;
    requestURL =
      this.URL +
      Values.API_RESOURCES.EMAILTEMPLATES +
      this.reqPattern +
      Values.EMAILTEMPLATES_REQS.UPDATE_TEMPLATE_PDF;

    let body = JSON.stringify({ template });

    let requestOptions = this.getRequestOptions();

    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public deleteTemplatePdf(templateId) {
    let requestURL: any;
    requestURL =
      this.URL +
      Values.API_RESOURCES.EMAILTEMPLATES +
      this.reqPattern +
      Values.EMAILTEMPLATES_REQS.DELETE_TEMPLATE_PDF;

    let body = JSON.stringify({ templateId });

    let requestOptions = this.getRequestOptions();

    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public insertTemplateType(templateType) {
    let requestURL: any;
    requestURL =
      this.URL +
      Values.API_RESOURCES.EMAILTEMPLATES +
      this.reqPattern +
      Values.EMAILTEMPLATES_REQS.INSERT_TEMPLATE_TYPE;

    let body = JSON.stringify({ templateType });

    let requestOptions = this.getRequestOptions();

    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public deleteTemplateType(templateTypeId) {
    let requestURL: any;
    requestURL =
      this.URL +
      Values.API_RESOURCES.EMAILTEMPLATES +
      this.reqPattern +
      Values.EMAILTEMPLATES_REQS.DELETE_TEMPLATE_TYPE;

    let body = JSON.stringify({ templateTypeId });

    let requestOptions = this.getRequestOptions();

    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getTemplatePredefinedSelectorValues() {
    let requestURL: any;
    requestURL =
      this.URL +
      Values.API_RESOURCES.EMAILTEMPLATES +
      this.reqPattern +
      Values.EMAILTEMPLATES_REQS.TEMPLATE_SELECTORS;

    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  /************************
   *
   *
   * Target lists
   *
   *
   *************************/

  public getAllTargetLists(inmoId, type) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.TARGETLIST +
      this.reqPattern +
      Values.TARGETLIST_REQS.GET_ALL_TARGET_LISTS;
    let body = JSON.stringify({ inmoId, type });
    return this.http.post(requestURL, body).pipe(map((response) => response));
    //return this.http.get<any[]>(requestURL).pipe(map(response => response));
  }

  public getTargetList(listID) {
    const idParam = "&listID=";
    const reqParam = listID;

    let requestURL: any;
    requestURL =
      this.URL +
      Values.API_RESOURCES.TARGETLIST +
      this.reqPattern +
      Values.TARGETLIST_REQS.GET_TARGET_LIST;
    requestURL += idParam + reqParam;

    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public insertTargetList(list, inmoId, type) {
    let requestURL: any;

    requestURL =
      this.URL +
      Values.API_RESOURCES.TARGETLIST +
      this.reqPattern +
      Values.TARGETLIST_REQS.INSERT_TARGET_LIST;

    let body = JSON.stringify({ list, inmoId, type });

    let requestOptions = this.getRequestOptions();

    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public updateTargetList(list) {
    let requestURL: any;
    requestURL =
      this.URL +
      Values.API_RESOURCES.TARGETLIST +
      this.reqPattern +
      Values.TARGETLIST_REQS.UPDATE_TARGET_LIST;

    let body = JSON.stringify({ list });

    let requestOptions = this.getRequestOptions();

    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public deleteTargetList(listID) {
    let requestURL: any;
    requestURL =
      this.URL +
      Values.API_RESOURCES.TARGETLIST +
      this.reqPattern +
      Values.TARGETLIST_REQS.DELETE_TARGET_LIST;

    let body = JSON.stringify({ listID });

    let requestOptions = this.getRequestOptions();

    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public executeCron() {
    const requestURL =
      this.URL + Values.API_RESOURCES.EVENTS + this.reqPattern + "execute-cron";
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public executeEgoCron() {
    const requestURL =
      this.URL +
      Values.API_RESOURCES.EVENTS +
      this.reqPattern +
      "execute-ego-cron";
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getConditionsSelectorsValues(tipo_evento, inmoId, isCampaign) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.EVENTS +
      this.reqPattern +
      Values.EVENTS_REQS.CONDITION_SELECTORS;
    requestURL += "&eventType=" + tipo_evento;
    requestURL += "&inmoId=" + inmoId;
    requestURL += "&isCampaign=" + isCampaign;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getEventsModulos(profile: number, reportId: number) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.EVENTS +
      this.reqPattern +
      Values.EVENTS_REQS.GET_EVENTS_MODULOS;
    requestURL += "&profile=" + profile + "&reportId=" + reportId;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getListExternField(moduloId: number) {
    const idParam = "&moduloId=";
    const reqParam = moduloId;
    let requestURL =
      this.URL +
      Values.API_RESOURCES.EVENTS +
      this.reqPattern +
      Values.EVENTS_REQS.GET_LIST_EXTERN;
    requestURL += idParam + reqParam;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getAllReports(permission, profile, user) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.EVENTS +
      this.reqPattern +
      Values.EVENTS_REQS.GET_ALL_REPORTS;
    requestURL +=
      "&permission=" + permission + "&profile=" + profile + "&user=" + user;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public duplicateReport(idReport: number, creator: number) {
    const body = JSON.stringify({ idReport: idReport, creator: creator });
    const requestOptions = this.getRequestOptions();
    const requestURL =
      this.URL +
      Values.API_RESOURCES.EVENTS +
      this.reqPattern +
      Values.EVENTS_REQS.DUPLICATE_REPORT;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getReportUserPermissionList(idReport) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.EVENTS +
      this.reqPattern +
      Values.EVENTS_REQS.GET_REPORT_USER_PERMISSION;

    requestURL += "&idReport=" + idReport;

    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public insertReportUserPermissionList(idReport, list) {
    const body = JSON.stringify({ idReport: idReport, list: list });
    const requestOptions = this.getRequestOptions();
    const requestURL =
      this.URL +
      Values.API_RESOURCES.EVENTS +
      this.reqPattern +
      Values.EVENTS_REQS.INSERT_REPORT_USER_PERMISSION;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getReport(id: number) {
    const idParam = "&reportId=";
    const reqParam = id;
    let requestURL =
      this.URL +
      Values.API_RESOURCES.EVENTS +
      this.reqPattern +
      Values.EVENTS_REQS.GET_WORKFLOW_REPORT;
    requestURL += idParam + reqParam;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public deleteReport(Id: number) {
    const body = JSON.stringify({ reportId: Id });
    const requestOptions = this.getRequestOptions();
    const requestURL =
      this.URL +
      Values.API_RESOURCES.EVENTS +
      this.reqPattern +
      Values.EVENTS_REQS.DELETE_REPORT;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  /*public updateWorkflowReport(element: WorkflowReportBody) {
		const body = JSON.stringify({ 'workflowReport': element });
		const requestOptions = this.getRequestOptions();
		const requestURL = this.URL + Values.API_RESOURCES.EVENTS + this.reqPattern + Values.EVENTS_REQS.UPDATE_REPORT;
		return this.http.post(requestURL, body).pipe(map(response => response));
	}*/

  public addTrackingLink(template, name, link, linkArray, button) {
    //console.log(bodyy);

    //const body = JSON.stringify(bodyy);
    const body = JSON.stringify({ template, name, link, linkArray, button });
    const requestOptions = this.getRequestOptions();
    const requestURL =
      this.URL +
      Values.API_RESOURCES.EVENTS +
      this.reqPattern +
      Values.EVENTS_REQS.INSERT_TRACKING_LINK;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  /*public insertWorkflowReport(element: WorkflowReportBody) {
		const body = JSON.stringify({ 'workflowReport': element });
		const requestOptions = this.getRequestOptions();
		const requestURL = this.URL + Values.API_RESOURCES.EVENTS + this.reqPattern + Values.EVENTS_REQS.INSERT_REPORT;
		return this.http.post(requestURL, body).pipe(map(response => response));
	}*/

  public getEvent(eventID) {
    const idParam = "&eventID=";
    const reqParam = eventID;
    let requestURL: any;
    requestURL =
      this.URL +
      Values.API_RESOURCES.EVENTS +
      this.reqPattern +
      Values.EVENTS_REQS.GET_EVENT;
    requestURL += idParam + reqParam;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getWorkflowReportValues() {
    let requestURL: any;
    requestURL =
      this.URL +
      Values.API_RESOURCES.EVENTS +
      this.reqPattern +
      Values.EVENTS_REQS.GET_REPORT;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public insertEvent(eventBody, tipo) {
    let requestURL: any;
    requestURL =
      this.URL +
      Values.API_RESOURCES.EVENTS +
      this.reqPattern +
      Values.EVENTS_REQS.INSERT_EVENT;
    const body = JSON.stringify({ eventBody, tipo });
    console.log(body);
    const requestOptions = this.getRequestOptions();
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }
  public updateEvent(eventBody) {
    let requestURL: any;
    requestURL =
      this.URL +
      Values.API_RESOURCES.EVENTS +
      this.reqPattern +
      Values.EVENTS_REQS.UPDATE_EVENT;
    const body = JSON.stringify({ eventBody });
    console.log(body);
    const requestOptions = this.getRequestOptions();
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public eventsGetClients(inmoId) {
    const body = JSON.stringify({ inmoId });
    const requestOptions = this.getRequestOptions();
    const requestURL =
      this.URL +
      Values.API_RESOURCES.EVENTS +
      this.reqPattern +
      Values.EVENTS_REQS.SEARCH_CLIENTS;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public eventsGetCampaignsEmails(inmoId) {
    /*let requestURL: any;
		requestURL = this.URL + Values.API_RESOURCES.EVENTS + this.reqPattern + Values.EVENTS_REQS.GET_EMAILS;
		return this.http.get<any[]>(requestURL).pipe(map(response => response));*/

    const body = JSON.stringify({ inmoId });
    const requestOptions = this.getRequestOptions();
    let requestURL =
      this.URL +
      Values.API_RESOURCES.EVENTS +
      this.reqPattern +
      Values.EVENTS_REQS.GET_EMAILS;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public eventsGetUsers(inmoId, isGroup4DMovin) {
    const body = JSON.stringify({ inmoId, isGroup4DMovin });
    const requestOptions = this.getRequestOptions();
    let requestURL =
      this.URL +
      Values.API_RESOURCES.EVENTS +
      this.reqPattern +
      Values.EVENTS_REQS.GET_USERS;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getFieldsFrontendNames(idModule) {
    const idParam = "&idModule=";
    const reqParam = idModule;
    let requestURL: any;
    requestURL =
      this.URL +
      Values.API_RESOURCES.EVENTS +
      this.reqPattern +
      Values.EVENTS_REQS.GET_FIELDS_FRONTEND_NAMES;
    requestURL += idParam + reqParam;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getValuesForManagement() {
    let requestURL: any;
    requestURL =
      this.URL +
      Values.API_RESOURCES.EVENTS +
      this.reqPattern +
      Values.EVENTS_REQS.GET_VALUES_FOR_MANAGEMENT;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public editWorkflowElement(type: string, data: any) {
    const body = JSON.stringify({
      type: type,
      data: data,
    });
    const requestOptions = this.getRequestOptions();
    const requestURL =
      this.URL +
      Values.API_RESOURCES.EVENTS +
      this.reqPattern +
      Values.EVENTS_REQS.EDIT_WORKFLOW_MANAGEMENT;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public createWorkflowElement(type: string, data: any) {
    const body = JSON.stringify({
      type: type,
      data: data,
    });
    const requestOptions = this.getRequestOptions();
    const requestURL =
      this.URL +
      Values.API_RESOURCES.EVENTS +
      this.reqPattern +
      Values.EVENTS_REQS.CREATE_WORKFLOW_MANAGEMENT;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public updateMRMFields() {
    let requestURL: any;
    requestURL =
      this.URL +
      Values.API_RESOURCES.EVENTS +
      this.reqPattern +
      Values.EVENTS_REQS.UPDATE_MRM_FIELDS;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  /************************
   *
   *
   * Campaigns
   *
   *
   *************************/

  public getAllCampaigns(inmoId) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.EVENTS +
      this.reqPattern +
      Values.EVENTS_REQS.GET_ALL_CAMPAIGNS;
    let body = JSON.stringify({ inmoId });
    let requestOptions = this.getRequestOptions();
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getCampaign(campaignId) {
    const idParam = "&campaignID=";
    const reqParam = campaignId;

    let requestURL: any;
    requestURL =
      this.URL +
      Values.API_RESOURCES.EVENTS +
      this.reqPattern +
      Values.EVENTS_REQS.GET_CAMPAIGN;
    requestURL += idParam + reqParam;

    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public sendEmails(emails, campaignId) {
    let requestURL: any;
    requestURL =
      this.URL +
      Values.API_RESOURCES.EVENTS +
      this.reqPattern +
      Values.EVENTS_REQS.SEND_EMAILS;
    const body = JSON.stringify({ emails: emails, campaignId: campaignId });
    const requestOptions = this.getRequestOptions();
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public insertCampaign(campaign, inmoId) {
    let requestURL: any;
    requestURL =
      this.URL +
      Values.API_RESOURCES.EVENTS +
      this.reqPattern +
      Values.EVENTS_REQS.INSERT_CAMPAIGN;
    let body = JSON.stringify({ campaignBody: campaign, inmoId });
    let requestOptions = this.getRequestOptions();
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public updateCampaign(campaign) {
    let requestURL: any;
    requestURL =
      this.URL +
      Values.API_RESOURCES.EVENTS +
      this.reqPattern +
      Values.EVENTS_REQS.UPDATE_CAMPAIGN;
    let body = JSON.stringify({ campaignBody: campaign });
    let requestOptions = this.getRequestOptions();
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public deleteCampaign(campaignId) {
    let requestURL: any;
    requestURL =
      this.URL +
      Values.API_RESOURCES.EVENTS +
      this.reqPattern +
      Values.EVENTS_REQS.DELETE_CAMPAIGN;

    let body = JSON.stringify({ campaignId });

    let requestOptions = this.getRequestOptions();

    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  /************************
   *
   *
   * User Monitoring
   *
   *
   *************************/
  public insertMonitoringInformation(user_id, area, custom_id, staticHTML) {
    //(user_id, name, text1, text2, dId) {
    let params = {
      custom_id: custom_id,
      params: localStorage.getItem("paramControl"),
    };
    const date = new Date();
    let information = {
      user_id: user_id,
      functional_area: area,
      //name: name,
      //view_visited: text1,
      //details: text2,
      detailsId: params,
      date: {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
        hour: date.getHours(),
        minute: date.getMinutes(),
        second: date.getSeconds(),
      },
      staticHTML: staticHTML,
    };
    let requestURL: any;

    requestURL =
      this.URL +
      Values.API_RESOURCES.USERMONITORING +
      this.reqPattern +
      Values.USER_MONITORING_REQS.INSERT;

    let body = JSON.stringify({ information });

    let requestOptions = this.getRequestOptions();

    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public updateMonitoringInformation(id: number, staticHTML) {
    const date = new Date();
    let information = {
      id: id,
      date: {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
        hour: date.getHours(),
        minute: date.getMinutes(),
        second: date.getSeconds(),
      },
      staticHTML: staticHTML,
    };
    let requestURL: any;

    requestURL =
      this.URL +
      Values.API_RESOURCES.USERMONITORING +
      this.reqPattern +
      Values.USER_MONITORING_REQS.UPDATE;

    let body = JSON.stringify({ information });
    let data = JSON.stringify(information.date);
    let requestOptions = this.getRequestOptions();

    /*$.ajax({
      type: 'PUT',
      async: false,
      url: requestURL,
      data: "id="+id+"&data="+data,
      success: function(data){
        console.log('UPDATE PERFORMED', data);
        alert(data);
      }
  });*/
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public insertMonitoringIdFunction(user_id, area, id_function) {
    const date = new Date();
    let information = {
      user_id: user_id,
      functional_area: area,
      //name: name,
      //view_visited: text1,
      //details: text2,
      id_function: id_function,
      date: {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
        hour: date.getHours(),
        minute: date.getMinutes(),
        second: date.getSeconds(),
      },
    };

    let requestURL: any;
    requestURL =
      this.URL +
      Values.API_RESOURCES.USERMONITORING +
      this.reqPattern +
      Values.USER_MONITORING_REQS.INSERT_FUNCTIONS;

    let body = JSON.stringify({ information });

    let requestOptions = this.getRequestOptions();

    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  //
  //
  //
  // PRIVATE METHODS
  //
  //
  //
  private getJSONHeaders() {
    //let headers = new Headers({'Content-Type': 'application/json'});
    return "";
  }

  private getNoCacheHeaders() {
    //let headers = new Headers({'Cache-Control': 'no-cache, no-store, must-revalidate'});
    return "";
  }

  private getNoCacheOptions() {
    let noCacheHeaders = this.getNoCacheHeaders();
    //let requestOptions = new RequestOptions({headers: noCacheHeaders});
    return "";
  }

  private getRequestOptions() {
    let JSONHeaders = this.getJSONHeaders();
    //let requestOptions = new RequestOptions({headers: JSONHeaders});
    return "";
  }

  loadPredefinedValuesService(idModulo: number, fieldName: string) {
    const idModuloParam = "&idModulo=";
    const fieldNameParam = "&fieldName=";
    let requestURL =
      this.URL +
      Values.API_RESOURCES.EVENTS +
      this.reqPattern +
      Values.EVENTS_REQS.LOAD_PREDEFINED_VALUES;
    requestURL += idModuloParam + idModulo;
    requestURL += fieldNameParam + fieldName;
    let options = this.getNoCacheOptions();
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  loadExternValuesService(idModulo: number) {
    const idModuloParam = "&idModulo=";
    //const fieldNameParam = '&fieldId=';
    let requestURL =
      this.URL +
      Values.API_RESOURCES.EVENTS +
      this.reqPattern +
      Values.EVENTS_REQS.LOAD_EXTERN_VALUES;
    requestURL += idModuloParam + idModulo;
    //requestURL += fieldNameParam + fieldId;
    let options = this.getNoCacheOptions();
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getFieldMRMValues() {
    let requestURL: any;
    requestURL =
      this.URL +
      Values.API_RESOURCES.EVENTS +
      this.reqPattern +
      Values.EVENTS_REQS.GET_FIELDS_MRM;
    let options = this.getNoCacheOptions();
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getCampaignsFieldsRelatedModulo() {
    let requestURL: any;
    requestURL =
      this.URL +
      Values.API_RESOURCES.EVENTS +
      this.reqPattern +
      Values.EVENTS_REQS.GET_CAMPAIGNS_FIELDS_MRM;
    let options = this.getNoCacheOptions();
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  /************************
   *
   *
   * Settings
   *
   *
   *************************/

  public getSettingsValues() {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.SETTINGS +
      this.reqPattern +
      Values.SETTINGS.GET_SETTINGS_VALUES;

    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getSettingsNames() {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.SETTINGS +
      this.reqPattern +
      Values.SETTINGS.GET_SETTINGS_NAMES;

    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public updateSettings(settingsBody) {
    let body = JSON.stringify({ settingsBody: settingsBody });
    let requestOptions = this.getRequestOptions();
    let requestURL =
      this.URL +
      Values.API_RESOURCES.SETTINGS +
      this.reqPattern +
      Values.SETTINGS.UPDATE_SETTINGS;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public updateSettingActive(id) {
    let body = JSON.stringify({ id: id });
    let requestOptions = this.getRequestOptions();
    let requestURL =
      this.URL +
      Values.API_RESOURCES.SETTINGS +
      this.reqPattern +
      Values.SETTINGS.UPDATE_SETTING_ACTIVE;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public deleteSetting(id) {
    let body = JSON.stringify({ id: id });
    let requestOptions = this.getRequestOptions();
    let requestURL =
      this.URL +
      Values.API_RESOURCES.SETTINGS +
      this.reqPattern +
      Values.SETTINGS.DELETE_SETTING;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public addSettings(settingsBody) {
    let body = JSON.stringify({ settingsBody: settingsBody });
    let requestOptions = this.getRequestOptions();
    let requestURL =
      this.URL +
      Values.API_RESOURCES.SETTINGS +
      this.reqPattern +
      Values.SETTINGS.ADD_SETTING;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  /*******
   * FILE UPLOADER
   */
  public uploadFile(idUser: number, formData, name, table, idInmo) {
    //check what type of uploadFileis
    let idParam = "&name=";
    let requestURL: any;
    formData.append("userID", idUser);
    if (name) {
      formData.append("elementName", name);
    }
    requestURL =
      this.URL +
      Values.API_RESOURCES.FILES +
      this.reqPattern +
      Values.FILES_REQS.UPLOAD_FILE;
    requestURL += idParam + name;
    requestURL += "&table=" + table;
    requestURL += "&idInmo=" + idInmo;
    let headers = new HttpHeaders();
    headers.append("Content-Type", "multipart/form-data");
    headers.append("Accept", "application/json");
    //let options = new RequestOptions({ headers: headers });
    return this.http
      .post(requestURL, formData, { headers })
      .pipe(map((response) => response));
  }

  public getAllFiles(idInmo) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.FILES +
      this.reqPattern +
      Values.FILES_REQS.GET_ALL_FILES;

    requestURL += "&idInmo=" + idInmo;

    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  generateReport(id: number, modulesIdList, rol, userId) {
    let requestURL: any;
    requestURL =
      this.URL +
      Values.API_RESOURCES.EVENTS +
      this.reqPattern +
      Values.EVENTS_REQS.GENERATE_REPORT;
    requestURL +=
      "&reportId=" +
      id +
      "&modulesIdList=" +
      modulesIdList +
      "&rol=" +
      rol +
      "&userId=" +
      userId;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  generateReportAsPdf(id: number, modulesIdList, rol, userId) {
    let requestURL: any;
    requestURL =
      this.URL +
      Values.API_RESOURCES.EVENTS +
      this.reqPattern +
      Values.EVENTS_REQS.GENERATE_REPORT_AS_PDF;
    requestURL +=
      "&reportId=" +
      id +
      "&modulesIdList=" +
      modulesIdList +
      "&rol=" +
      rol +
      "&userId=" +
      userId;
    /*return this.http.get(requestURL, {responseType: ResponseContentType.ArrayBuffer}).map(
		  response => new Blob([response.blob()], {type: 'application/pdf'}));*/
    return this.http
      .get(requestURL, { responseType: "blob" })
      .pipe(map((response) => response));
  }

  public getAllCountry() {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.PROPERTIES +
      this.reqPattern +
      Values.PROPERTIES_REQS.GET_ALL_COUNTRY;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getProvince() {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.PROPERTIES +
      this.reqPattern +
      Values.PROPERTIES_REQS.GET_PROVINCE;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public updateSerie(serieRental, serieSale, serieYear) {
    let body = JSON.stringify({
      serieRental: serieRental,
      serieSale: serieSale,
      serieYear: serieYear,
    });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.PROPERTIES +
      this.reqPattern +
      Values.PROPERTIES_REQS.UPDATE_SERIE;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public insertSerie(serieRental, serieSale, serieYear) {
    let body = JSON.stringify({
      serieRental: serieRental,
      serieSale: serieSale,
      serieYear: serieYear,
    });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.PROPERTIES +
      this.reqPattern +
      Values.PROPERTIES_REQS.INSERT_SERIE;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public createInmoDemo(idUser: number) {
    let body = JSON.stringify({ idUser });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.INMO +
      this.reqPattern +
      Values.INMO_REQS.CREATE_INMO_DEMO;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public loadClientsFromFile(
    data,
    formFields: any,
    removed: any,
    imageUpload,
    params
  ) {
    let formData: FormData = new FormData();
    formData.append(
      "fields",
      JSON.stringify({ data, formFields, removed, params })
    );
    if (imageUpload.length > 0) {
      let files = [];
      let j = 0;
      for (let i in imageUpload) {
        if (imageUpload[i]["tmp_value"]) {
          imageUpload[i]["tmp_value"].forEach((t) => {
            formData.append(String(j), t);
            j++;
          });
        }
      }
    }
    formData.forEach((r) => console.log("FORMDATA: ", r));
    let headers = new HttpHeaders();
    headers.append("Content-Type", "multipart/form-data");
    headers.append("Accept", "application/json");
    let requestURL =
      this.URL +
      Values.API_RESOURCES.LOAD_DATA_FROM_FILE +
      this.reqPattern +
      Values.LOAD_DATA_FROM_FILE.LOAD_CLIENTS_FROM_FILE;
    console.log(requestURL);

    return this.http
      .post(requestURL, formData, { headers })
      .pipe(map((response) => response));
  }

  public ContactForm(name, mail, inmoName, tel, comment) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.EMAILTEMPLATES +
      this.reqPattern +
      Values.EMAILTEMPLATES_REQS.SEND_CONTACT_MAIL;
    requestURL +=
      "&name=" +
      name +
      "&mail=" +
      mail +
      "&inmoName=" +
      inmoName +
      "&tel=" +
      tel +
      "&comment=" +
      comment;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public InsertContactInfo(
    name,
    mail,
    inmoName,
    tel,
    comment,
    privacy,
    newsletter
  ) {
    let body = JSON.stringify({
      name: name,
      mail: mail,
      inmoName: inmoName,
      tel: tel,
      comment: comment,
      privacy: privacy,
      newsletter: newsletter,
    });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.EMAILTEMPLATES +
      this.reqPattern +
      Values.EMAILTEMPLATES_REQS.INSERT_CONTACT_INFO;
    // requestURL += '&name=' + name +'&mail=' + mail +'&inmoName=' + inmoName + '&tel=' + tel +'&comment=' + comment + '&privacy=' + privacy + '&newsletter=' + newsletter;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getActivitySerieMaxId() {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.ACTIVITIES +
      this.reqPattern +
      Values.ACTIVITIES_REQS.GET_ACTIVITIES_SERIES_MAX_ID;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getActivitiesNotificationTiming() {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.ACTIVITIES +
      this.reqPattern +
      Values.ACTIVITIES_REQS.GET_ACTIVITIES_NOTIFICATION_TIMING;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getAllFullNamesAndIdsByEmpresa(idEmpresa: number) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.USER +
      this.reqPattern +
      Values.USER_REQS.GET_ALL_FULL_NAMES_AND_IDS_BY_EMPRESA;
    requestURL += "&idEmpresa=" + idEmpresa;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getOffersByIdEmpresa(empresaId: number, idUser) {
    let body = JSON.stringify({ empresaId, idUser });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.ACTIVITIES +
      this.reqPattern +
      Values.ACTIVITIES_REQS.GET_OFFERS_BY_ID_EMPRESA;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public deleteCalendarSerieActivities(idSerie) {
    const nameValue = "&idSerie=";
    const reqParam1 = idSerie;
    let requestURL =
      this.URL +
      Values.API_RESOURCES.ACTIVITIES +
      this.reqPattern +
      Values.ACTIVITIES_REQS.DELETE_CALENDAR_SERIE_ACTIVITIES;
    requestURL += nameValue + reqParam1;
    return this.http.post(requestURL, null).pipe(map((response) => response));
  }

  public getSoftware() {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.INMO +
      this.reqPattern +
      Values.INMO_REQS.GET_SOFTWARE;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getPortal() {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.INMO +
      this.reqPattern +
      Values.INMO_REQS.GET_PORTAL;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getGroupType() {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.INMO +
      this.reqPattern +
      Values.INMO_REQS.GET_GROUP_TYPE;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getModule() {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.INMO +
      this.reqPattern +
      Values.INMO_REQS.GET_MODULE;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public updateActivityState(activity, state) {
    let body = JSON.stringify({ idActivity: activity, state: state });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.ACTIVITIES +
      this.reqPattern +
      Values.ACTIVITIES_REQS.UPDATE_ACTIVITY_STATE;
    console.log("test", requestURL);
    let requestOptions = this.getRequestOptions();
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public cancelActivityState(activity, state, motivo) {
    let body = JSON.stringify({
      idActivity: activity,
      state: state,
      motivo: motivo,
    });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.ACTIVITIES +
      this.reqPattern +
      Values.ACTIVITIES_REQS.CANCEL_ACTIVITY_STATE;
    let requestOptions = this.getRequestOptions();
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public postponeActivity(calendarEvent, idActivity) {
    const nameValue = "&idActivity=";
    const reqParam1 = idActivity;
    let requestURL =
      this.URL +
      Values.API_RESOURCES.ACTIVITIES +
      this.reqPattern +
      Values.ACTIVITIES_REQS.POSTPONE_ACTIVITY;
    requestURL += nameValue + reqParam1;
    let body = JSON.stringify({ calendarEvent });
    let requestOptions = this.getRequestOptions();
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getAllMyAccountsUsersExceptMe(idEmpresa: number, idUser: number) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.USER +
      this.reqPattern +
      Values.USER_REQS.GET_ALL_MY_ACCOUNTS_USERS_EXCEPT_ME;
    requestURL += "&idEmpresa=" + idEmpresa;
    requestURL += "&idUser=" + idUser;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getAllMyAccountsUsers(idEmpresa: number, idUser: number) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.USER +
      this.reqPattern +
      Values.USER_REQS.GET_ALL_MY_ACCOUNTS_USERS;
    requestURL += "&idEmpresa=" + idEmpresa;
    requestURL += "&idUser=" + idUser;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public insertScheduleView(schedulesArray, idUser: number) {
    let body = JSON.stringify({
      schedulesArray: schedulesArray,
      idUser: idUser,
    });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.USER +
      this.reqPattern +
      Values.USER_REQS.INSERT_SCHEDULE_VIEW;
    return this.http
      .post<any[]>(requestURL, body)
      .pipe(map((response) => response));
  }

  public deleteImageProfile(imgName, idUser: number, idInmo: number) {
    let body = JSON.stringify({
      imgName: imgName,
      idUser: idUser,
      idInmo: idInmo,
    });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.USER +
      this.reqPattern +
      Values.USER_REQS.DELETE_IMAGE_PROFILE;
    return this.http
      .post<any[]>(requestURL, body)
      .pipe(map((response) => response));
  }
  public getAllGroups(idUser) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.ACTIVITIES +
      this.reqPattern +
      Values.ACTIVITIES_REQS.GET_ALL_GROUPS;
    // requestURL += '&idInmo=' + idInmo;
    requestURL += "&idUser=" + idUser;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getAllGroupUsersById(idGroup, idUser) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.ACTIVITIES +
      this.reqPattern +
      Values.ACTIVITIES_REQS.GET_ALL_GROUP_USERS_BY_ID;
    requestURL += "&idGroup=" + idGroup;
    requestURL += "&idUser=" + idUser;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public insertGroup(groupInfo) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.ACTIVITIES +
      this.reqPattern +
      Values.ACTIVITIES_REQS.INSERT_GROUP_USERS;
    let body = JSON.stringify({ groupInfo });
    return this.http.post(requestURL, body).pipe(map((response) => response));
    // return this.http.get<any[]>(requestURL).pipe(map(response => response));
  }

  public deleteGroup(idGroup) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.ACTIVITIES +
      this.reqPattern +
      Values.ACTIVITIES_REQS.DELETE_GROUP_USERS;
    requestURL += "&idGroup=" + idGroup;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getTempleteView(idTemplete, tipo) {
    //retorna la localización del pdf creado. Pdf creado segun la plantilla elegida (el pdf se crea en el backend)
    let requestURL =
      this.URL +
      Values.API_RESOURCES.EMAILTEMPLATES +
      this.reqPattern +
      Values.EMAILTEMPLATES_REQS.GET_TEMPLETE_VIEW;
    requestURL += "&idTemplete=" + idTemplete + "&tipo=" + tipo;

    return this.http
      .get(requestURL, { responseType: "blob" })
      .pipe(map((response) => response)); //para passar un pdf o fitero desde el backend
  }

  public uploadTempleteImage(formData, idInmo) {
    const headers = new HttpHeaders();

    let requestURL =
      this.URL +
      Values.API_RESOURCES.EMAILTEMPLATES +
      this.reqPattern +
      Values.EMAILTEMPLATES_REQS.UPLOAD_TEMPLETE_IMAGE;

    requestURL += "&idInmo=" + idInmo;

    //return this.http.post(requestURL, formData, { headers }).pipe(map(response => response));

    return this.http.post<any>(requestURL, formData, {
      reportProgress: true,
      observe: "events",
    });
  }

  public insertEgoImage(formData) {
    const headers = new HttpHeaders();

    let requestURL =
      this.URL +
      Values.API_RESOURCES.EGO_NOTIFICATIONS +
      this.reqPattern +
      Values.EGONOTIFICATIONS_REQS.INSERT_EGO_IMAGE;

    console.log("PRUEBAS IMAGE");
    console.log(requestURL);
    console.log(Values);
    console.log(Values.EGONOTIFICATIONS_REQS);

    //return this.http.post(requestURL, formData, { headers }).pipe(map(response => response));

    return this.http.post<any>(requestURL, formData, {
      reportProgress: true,
      observe: "events",
    });
  }

  public deleteTempleteImage(url) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.EMAILTEMPLATES +
      this.reqPattern +
      Values.EMAILTEMPLATES_REQS.DELETE_TEMPLETE_IMAGE;

    requestURL += "&url=" + url;

    return this.http.post(requestURL, null).pipe(map((response) => response));
  }

  public deleteImageEgo(url) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.EGO_NOTIFICATIONS +
      this.reqPattern +
      Values.EGONOTIFICATIONS_REQS.DELETE_IMAGE_EGO;

    requestURL += "&url=" + url;

    return this.http.post(requestURL, null).pipe(map((response) => response));
  }

  public updateUserGroup(idGroup, groupInfo) {
    const body = JSON.stringify({ idGroup, groupInfo });
    const requestOptions = this.getRequestOptions();
    const requestURL =
      this.URL +
      Values.API_RESOURCES.ACTIVITIES +
      this.reqPattern +
      Values.ACTIVITIES_REQS.UPDATE_USER_GROUP;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public commercialAcceptedVisit(userId, notification) {
    const body = JSON.stringify({ userId, notification });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMON +
      this.reqPattern +
      Values.COMMON_REQS.COMMERCIAL_ACCEPTED_VISIT;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public commercialRejectedVisit(userId, notification) {
    const body = JSON.stringify({ userId, notification });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMON +
      this.reqPattern +
      Values.COMMON_REQS.COMMERCIAL_REJECTED_VISIT;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getCommercialNotifications(userId) {
    const body = JSON.stringify({ userId });
    //console.log('BODY --> ' + JSON.stringify(body));
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMON +
      this.reqPattern +
      Values.COMMON_REQS.GET_COMMERCIAL_NOTIFICATIONS;
    //console.log('requestURL', requestURL);
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getActivitiesNotifications(userId) {
    const body = JSON.stringify({ userId });
    //console.log('BODY --> ' + JSON.stringify(body));
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMON +
      this.reqPattern +
      Values.COMMON_REQS.GET_ACTIVITIES_NOTIFICATIONS;
    //console.log('requestURL getActivitiesNotifications', requestURL);
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public deleteNotification(notificationId: number) {
    let body = JSON.stringify({ notificationId });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMON +
      this.reqPattern +
      Values.COMMON_REQS.DELETE_NOTIFICATION;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  /* TOUR */
  public CreateTour(
    nombre,
    calle,
    poblacion,
    planta,
    puerta,
    num_plantas,
    referencia,
    tamaño,
    token
  ) {
    let body = JSON.stringify({
      nombre,
      calle,
      poblacion,
      planta,
      puerta,
      num_plantas,
      referencia,
      tamaño,
    });
    let requestURL = "https://server.creotour.com/api/tour-create?t=" + token;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public DeleteTour(token, idTour) {
    let body = JSON.stringify({ token, idTour });
    let requestURL =
      "https://server.creotour.com/api/tour-delete?t=" +
      token +
      "&id=" +
      idTour;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getPropertyTourToken(idProperty) {
    let body = JSON.stringify({ idProperty });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.INMO +
      this.reqPattern +
      "get-property-tour-token";
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getPropertyLocation(idProperty) {
    let body = JSON.stringify({ idProperty });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.INMO +
      this.reqPattern +
      "get-property-location";
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getClientLocation(idClient) {
    let body = JSON.stringify({ idClient });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.INMO +
      this.reqPattern +
      "get-client-location";
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public updatePropertyTourId(idProperty, idTour) {
    let body = JSON.stringify({ idProperty, idTour });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.PROPERTIES +
      this.reqPattern +
      "update-property-tour-id";
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public UpdateTourState(token, idTour, state) {
    let body = JSON.stringify({ token, idTour, state });
    let requestURL =
      "https://server.creotour.com/api/tour-state?t=" +
      token +
      "&id=" +
      idTour +
      "&status=" +
      state;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public generateToken(idInmo) {
    let body = JSON.stringify({ idInmo });
    let requestURL =
      this.URL + Values.API_RESOURCES.INMO + this.reqPattern + "generate-token";
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public updateTourPublicado(idProperty, status) {
    let body = JSON.stringify({ idProperty, status });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.PROPERTIES +
      this.reqPattern +
      "update-tour-publicado";
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public commercialAcceptedStreaming(userId, notification) {
    const body = JSON.stringify({ userId, notification });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMON +
      this.reqPattern +
      Values.COMMON_REQS.COMMERCIAL_ACCEPTED_STREAMING;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public commercialRejectedStreaming(userId, notification) {
    const body = JSON.stringify({ userId, notification });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMON +
      this.reqPattern +
      Values.COMMON_REQS.COMMERCIAL_REJECTED_STREAMING;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public commercialAcceptedLiveStreaming(userId, notification) {
    const body = JSON.stringify({ userId, notification });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMON +
      this.reqPattern +
      Values.COMMON_REQS.COMMERCIAL_ACCEPTED_LIVE_STREAMING;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public commercialRejectedLiveStreaming(userId, notification) {
    const body = JSON.stringify({ userId, notification });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMON +
      this.reqPattern +
      Values.COMMON_REQS.COMMERCIAL_REJECTED_LIVE_STREAMING;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public canThisInmoAccess(id, idInmo, type) {
    const body = JSON.stringify({ id, idInmo, type });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.PRIVILEGIES +
      this.reqPattern +
      "can-this-inmo-access";
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getFunctionsToExecuteByModule(modulo) {
    let requestURL: any;
    requestURL =
      this.URL +
      Values.API_RESOURCES.EVENTS +
      this.reqPattern +
      Values.EVENTS_REQS.GET_FUNCTIONS_TO_EXECUTE_BY_MODULE_ID;
    requestURL += "&modulo=" + modulo;
    console.log(requestURL);
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getDynamicReportTyper() {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.REPORT +
      this.reqPattern +
      Values.REPORT_REQS.GET_REPORT_TYPES;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getAllPlantillas() {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.REPORT +
      this.reqPattern +
      Values.REPORT_REQS.GET_ALL_PLANTILLAS;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getPlantilla(id, idEmpresa = null) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.REPORT +
      this.reqPattern +
      Values.REPORT_REQS.GET_PLANTILLA;
    requestURL += "&id=" + id + "&idEmpresa=" + idEmpresa;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public dropPlantilla(id) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.REPORT +
      this.reqPattern +
      Values.REPORT_REQS.DROP_PLANTILLA;
    requestURL += "&id=" + id;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public saveReport(bodyReport, containerArray, buttonArray, user, stepArray) {
    let body = JSON.stringify({
      bodyReport,
      containerArray,
      buttonArray,
      user,
      stepArray,
    });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.REPORT +
      this.reqPattern +
      Values.REPORT_REQS.SET_DYNAMIC_REPORT;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public updateReport(
    bodyReport,
    id,
    containerArray,
    buttonArray,
    dropContainerArray,
    stepArray,
    dropStepArray
  ) {
    let body = JSON.stringify({
      bodyReport,
      id,
      containerArray,
      buttonArray,
      dropContainerArray,
      stepArray,
      dropStepArray,
    });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.REPORT +
      this.reqPattern +
      Values.REPORT_REQS.UPDATE_PLANTILLA;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getPlanesMovin() {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.BILL +
      this.reqPattern +
      Values.BILL_REQS.GET_PLANES_MOVIN;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getPlanesComprados(idInmo: number) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.BILL +
      this.reqPattern +
      Values.BILL_REQS.GET_PLANES_COMPRADOS;
    requestURL += "&idInmo=" + idInmo;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getPlanesUsados(idInmo: number) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.BILL +
      this.reqPattern +
      Values.BILL_REQS.GET_PLANES_USADOS;
    requestURL += "&idInmo=" + idInmo;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public setPlanesMovin(
    idInmo,
    idUser,
    inmoNumber,
    finalPrice,
    idPlan,
    bodyInmo,
    bodyBill,
    n,
    dto,
    paid
  ) {
    let body = JSON.stringify({
      idInmo,
      idUser,
      inmoNumber,
      finalPrice,
      idPlan,
      bodyInmo,
      bodyBill,
      n,
      dto,
      paid,
    });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.BILL +
      this.reqPattern +
      Values.BILL_REQS.SET_PLANES_MOVIN;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public updatePropertyNumPlantes(numPlantas, idProperty) {
    let body = JSON.stringify({ numPlantas, idProperty });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.PROPERTIES +
      this.reqPattern +
      "update-num-plantas";
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public checkMovinsVisitaVirtual(idInmo, idUser, idProperty, idTour) {
    let body = JSON.stringify({ idInmo, idUser, idProperty, idTour });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.PROPERTIES +
      this.reqPattern +
      "check-movins-visita-virtual";
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public unsubscribeMovin(idInmo: number) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.BILL +
      this.reqPattern +
      Values.BILL_REQS.UNSUBSCRIBE;
    requestURL += "&idInmo=" + idInmo;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public totalMovinCoin(idInmo: number) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.BILL +
      this.reqPattern +
      Values.BILL_REQS.TOTAL;
    requestURL += "&idInmo=" + idInmo;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public chargePaymentStripe(token, amount, description, idInmo) {
    let body = JSON.stringify({ token, amount, description, idInmo });
    let requestURL =
      this.URL + Values.API_RESOURCES.BILL + this.reqPattern + "charge-payment";
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public checkInmoStripe(idInmo) {
    let body = JSON.stringify({ idInmo });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.BILL +
      this.reqPattern +
      "check-inmo-stripe";
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getTypeIcon() {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.REPORT +
      this.reqPattern +
      Values.REPORT_REQS.GET_TYPE_ICON;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public chargeInmoMovinsSubscription(idInmo, finalPrice, amount) {
    let body = JSON.stringify({ idInmo, finalPrice, amount });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.BILL +
      this.reqPattern +
      "charge-inmo-movins-subscription";
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getButtonActionReport() {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.REPORT +
      this.reqPattern +
      Values.REPORT_REQS.GET_ACTION_BUTTON;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getAllButtonActionReportActive(id) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.REPORT +
      this.reqPattern +
      Values.REPORT_REQS.GET_ALL_ACTION_BUTTON_ACTIVE;
    requestURL += "&id=" + id;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getButtonActionReportActive(id) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.REPORT +
      this.reqPattern +
      Values.REPORT_REQS.GET_ACTION_BUTTON_ACTIVE;
    requestURL += "&id=" + id;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public executeEgoButtonAction(id, actionBody) {
    let body = JSON.stringify({ id, actionBody });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.REPORT +
      this.reqPattern +
      Values.REPORT_REQS.EXECUTE_EGO_BUTTON_ACTION;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public newNotiEgo(user, company, idPlantilla) {
    let body = JSON.stringify({ user, company, idPlantilla });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.EGO_NOTIFICATIONS +
      this.reqPattern +
      Values.REPORT_REQS.NEW_NOTI_EGO;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public updateReportEvent(id, event) {
    let body = JSON.stringify({ id, event });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.REPORT +
      this.reqPattern +
      Values.REPORT_REQS.UPDATE_ID_EVENT;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getAllEgoNotifications(id) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.EGO_NOTIFICATIONS +
      this.reqPattern +
      Values.EGONOTIFICATIONS_REQS.GET_ALL_EGO_NOTIFICATIONS;
    requestURL += "&usid=" + id;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getEgoNotification(screen, user, company) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.EGO_NOTIFICATIONS +
      this.reqPattern +
      Values.EGONOTIFICATIONS_REQS.GET_EGO_NOTIFICATION;
    requestURL += "&screen=" + screen;
    requestURL += "&user=" + user;
    requestURL += "&company=" + company;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getEgoHomeNotifications(id, company) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.EGO_NOTIFICATIONS +
      this.reqPattern +
      Values.EGONOTIFICATIONS_REQS.GET_EGO_HOME_NOTIFICATION;
    requestURL += "&usid=" + id;
    requestURL += "&company=" + company;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getEgoNotificationSuperior(screen, user, company) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.EGO_NOTIFICATIONS +
      this.reqPattern +
      Values.EGONOTIFICATIONS_REQS.GET_EGO_SUPERIOR_NOTIFICATION;
    requestURL += "&screen=" + screen;
    requestURL += "&user=" + user;
    requestURL += "&company=" + company;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getQuestionsAndAnswers(screen) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.EGO_NOTIFICATIONS +
      this.reqPattern +
      Values.EGONOTIFICATIONS_REQS.GET_QUESTIONS;
    requestURL += "&screen=" + screen;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getNewsArea() {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.LANDING +
      this.reqPattern +
      Values.LANDING_REQS.GET_NEWS_AREA;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getCinema() {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.LANDING +
      this.reqPattern +
      Values.LANDING_REQS.GET_CINEMA;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getLibrary() {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.LANDING +
      this.reqPattern +
      Values.LANDING_REQS.GET_LIBRARY;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getReportSpace() {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.LANDING +
      this.reqPattern +
      Values.LANDING_REQS.GET_REPORT_SPACE;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getAcademy() {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.LANDING +
      this.reqPattern +
      Values.LANDING_REQS.GET_ACADEMY;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getPlaySpace() {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.LANDING +
      this.reqPattern +
      Values.LANDING_REQS.GET_PLAY_SPACE;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getTransformacion() {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.LANDING +
      this.reqPattern +
      Values.LANDING_REQS.GET_TRANSFORMACION;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  // ********************************************* MARKETPLACE *********************************************************

  public getModulosInmo(inmoId: number) {
    let body = JSON.stringify({ inmoId });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.MARKETPLACE +
      this.reqPattern +
      Values.MARKETPLACE_REQS.GET_MODULOS_INMO;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getModulosOfertas(inmoId: number) {
    let body = JSON.stringify({ inmoId });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.MARKETPLACE +
      this.reqPattern +
      Values.MARKETPLACE_REQS.GET_MODULOS_OFERTAS;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getPacks() {
    // let body = JSON.stringify({});
    let requestURL =
      this.URL +
      Values.API_RESOURCES.MARKETPLACE +
      this.reqPattern +
      Values.MARKETPLACE_REQS.GET_PACKS;
    //return this.http.post(requestURL, body).pipe(map(response => response));
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getModulosPacks(idPack: number) {
    let body = JSON.stringify({ idPack });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.MARKETPLACE +
      this.reqPattern +
      Values.MARKETPLACE_REQS.GET_MODULOS_PACKS;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getModulosDependientes(inmoId: number, moduloId: number) {
    let body = JSON.stringify({ inmoId, moduloId });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.MARKETPLACE +
      this.reqPattern +
      Values.MARKETPLACE_REQS.GET_MODULOS_DEPENDIENTES;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public inmoTieneModuloDependiente(
    inmoId: number,
    moduloDependienteId: number
  ) {
    let body = JSON.stringify({ inmoId, moduloDependienteId });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.MARKETPLACE +
      this.reqPattern +
      Values.MARKETPLACE_REQS.TIENE_MODULO_DEPENDIENTE;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public insertModuloInmo(
    inmoId: number,
    moduloId: number,
    precio: number,
    userId: number
  ) {
    let body = JSON.stringify({ inmoId, moduloId, precio, userId });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.MARKETPLACE +
      this.reqPattern +
      Values.MARKETPLACE_REQS.INSERT_MODULO_INMO;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public desactivarModuloInmo(inmoId: number, moduloId: number) {
    let body = JSON.stringify({ inmoId, moduloId });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.MARKETPLACE +
      this.reqPattern +
      Values.MARKETPLACE_REQS.DESACTIVAR_MODULO_INMO;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  //####################################################################################################################
  // NEW MARKETPLACE
  // 'get-products-of-company'
  // 'get-available-products'
  // 'get-dependencies-of-product'

  public getProductsOfCompany(
    idCompany: number,
    idTypeCompany: number,
    idLanguage: number
  ) {
    let body = JSON.stringify({ idCompany, idTypeCompany, idLanguage });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.MARKETPLACE +
      this.reqPattern +
      "get-products-of-company";
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getAvailableProducts(
    idCompany: number,
    idTypeCompany: number,
    idLanguage: number,
    idAdminArea: number
  ) {
    let body = JSON.stringify({
      idCompany,
      idTypeCompany,
      idLanguage,
      idAdminArea,
    });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.MARKETPLACE +
      this.reqPattern +
      "get-available-products";
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getInfoProduct(
    idCompany: number,
    idTypeCompany: number,
    idLanguage: number,
    idAdminArea: number,
    idModule: number
  ) {
    let body = JSON.stringify({
      idCompany,
      idTypeCompany,
      idLanguage,
      idAdminArea,
      idModule,
    });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.MARKETPLACE +
      this.reqPattern +
      "get-info-product";
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getComingSoonProducts(
    idCompany: number,
    idTypeCompany: number,
    idLanguage: number,
    idAdminArea: number
  ) {
    let body = JSON.stringify({
      idCompany,
      idTypeCompany,
      idLanguage,
      idAdminArea,
    });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.MARKETPLACE +
      this.reqPattern +
      "get-coming-soon-products";
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getDependenciesOfProduct(
    idModulo: number,
    idCompany: number,
    idTypeCompany: number,
    idLanguage: number,
    idAdminArea: number
  ) {
    let body = JSON.stringify({
      idModulo,
      idCompany,
      idTypeCompany,
      idLanguage,
      idAdminArea,
    });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.MARKETPLACE +
      this.reqPattern +
      "get-dependencies-of-product";
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getDependentsOfProduct(idProduct: number, idLanguage: number) {
    let body = JSON.stringify({ idProduct, idLanguage });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.MARKETPLACE +
      this.reqPattern +
      "get-dependents-of-product";
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getWidgetsByList(
    modules: any,
    idCompany: number,
    idTypeCompany: number,
    idLanguage: number,
    idAdminArea: number
  ) {
    let body = JSON.stringify({
      modules,
      idCompany,
      idTypeCompany,
      idLanguage,
      idAdminArea,
    });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.MARKETPLACE +
      this.reqPattern +
      "get-widgets";
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getMovinsInmo(idCompany: number, idTypeCompany: number) {
    let body = JSON.stringify({ idCompany, idTypeCompany });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.MARKETPLACE +
      this.reqPattern +
      "get-movins";
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public restarMovins(
    movinsRestar: number,
    idCompany: number,
    idTypeCompany: number
  ) {
    let body = JSON.stringify({
      movins: movinsRestar,
      idCompany,
      idTypeCompany,
    });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.MARKETPLACE +
      this.reqPattern +
      "restar-movins";
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public addProducts(
    idCompany: number,
    idTypeCompany: number,
    userId: number,
    carrito: any,
    totalCarro: number
  ) {
    let body = JSON.stringify({
      idCompany,
      idTypeCompany,
      userId,
      carrito,
      totalCarro,
    });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.MARKETPLACE +
      this.reqPattern +
      "add-products";
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public insertPlanMovin(
    idCompany: number,
    idTypeCompany: number,
    userId: number,
    movins: number,
    precio: number,
    paid: boolean
  ) {
    let body = JSON.stringify({
      idCompany,
      idTypeCompany,
      userId,
      movins,
      precio,
      discount: 0,
      active: paid,
    });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.MARKETPLACE +
      this.reqPattern +
      "add-plan-movin";
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public cancelarPlanMovin(idCompany: number, idTypeCompany: number) {
    let body = JSON.stringify({ idCompany, idTypeCompany });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.MARKETPLACE +
      this.reqPattern +
      "cancelar-plan";
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public productosRelacionados(
    product: number,
    idCompany: number,
    idTypeCompany: number,
    idLanguage: number,
    idAdminArea: number
  ) {
    let body = JSON.stringify({
      product,
      idCompany,
      idTypeCompany,
      idLanguage,
      idAdminArea,
    });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.MARKETPLACE +
      this.reqPattern +
      "get-productos-relacionados";
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getMovinsAdquiridos(idCompany: number, idTypeCompany: number) {
    let body = JSON.stringify({ idCompany, idTypeCompany });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.MARKETPLACE +
      this.reqPattern +
      "get-movins-adquiridos";
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getMovinsInvertidos(
    idCompany: number,
    idTypeCompany: number,
    languageId: number
  ) {
    let body = JSON.stringify({ idCompany, idTypeCompany, languageId });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.MARKETPLACE +
      this.reqPattern +
      "get-movins-invertidos";
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public insertarSingleCarrito(
    idCompany: number,
    idTypeCompany: number,
    idUser: number,
    carro: any,
    idLanguage: number
  ) {
    let body = JSON.stringify({
      idCompany,
      idTypeCompany,
      idUser,
      carro,
      idLanguage,
    });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.MARKETPLACE +
      this.reqPattern +
      "insert-single-carrito";
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public updateSingleCarrito(id: number) {
    let body = JSON.stringify({ id });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.MARKETPLACE +
      this.reqPattern +
      "update-single-carrito";
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public deleteElementsCarrito(elements: any, userId: number) {
    let body = JSON.stringify({ elements, userId });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.MARKETPLACE +
      this.reqPattern +
      "delete-elements-carrito";
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  /*public crearCarritoCompra() {
    let body = JSON.stringify({ });
    let requestURL = this.URL + Values.API_RESOURCES.MARKETPLACE + this.reqPattern + 'create-carrito-compra';
    return this.http.post(requestURL, body).pipe(map(response => response));
  }*/

  public getCarritoItems(
    idCompany: number,
    idTypeCompany: number,
    idUser: number,
    languageId: number
  ) {
    let body = JSON.stringify({ idCompany, idTypeCompany, idUser, languageId });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.MARKETPLACE +
      this.reqPattern +
      "get-carrito-items";
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public updateProductsEstate(products: any, estate: boolean) {
    let body = JSON.stringify({ products, estate });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.MARKETPLACE +
      this.reqPattern +
      "update-products-estate";
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public companyHaveSubscription(
    idCompany: number,
    companyType: number,
    adminArea: number
  ) {
    let body = JSON.stringify({ idCompany, companyType, adminArea });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.MARKETPLACE +
      this.reqPattern +
      "company-have-subscription";
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  //********************************************************************************************************************

  public clickEgoMonitoreo(idNot, idStep, idButton, idArea, user, iniDate) {
    const endDate = new Date();
    let information = {
      id_not: idNot,
      id_step: idStep,
      id_button: idButton,
      functional_area: idArea,
      id_user: user,
      iniDate: {
        year: iniDate.getFullYear(),
        month: iniDate.getMonth() + 1,
        day: iniDate.getDate(),
        hour: iniDate.getHours(),
        minute: iniDate.getMinutes(),
        second: iniDate.getSeconds(),
      },
      endDate: {
        year: endDate.getFullYear(),
        month: endDate.getMonth() + 1,
        day: endDate.getDate(),
        hour: endDate.getHours(),
        minute: endDate.getMinutes(),
        second: endDate.getSeconds(),
      },
    };

    let requestURL: any;

    requestURL =
      this.URL +
      Values.API_RESOURCES.EGO_NOTIFICATIONS +
      this.reqPattern +
      Values.EGONOTIFICATIONS_REQS.CLICK_EGO_MONITOREO;

    let body = JSON.stringify({ information });

    let requestOptions = this.getRequestOptions();

    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public insertEgoAction(idNot, horaInicio, horaFin, accion, infoAccion) {
    let body = JSON.stringify({
      idNot,
      horaInicio,
      horaFin,
      accion,
      infoAccion,
    });
    //console.log(body);
    let requestURL =
      this.URL +
      Values.API_RESOURCES.EGO_NOTIFICATIONS +
      this.reqPattern +
      Values.EGONOTIFICATIONS_REQS.INSERT_EGO_ACTION;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public deleteEgoNotification(idNot) {
    let body = JSON.stringify({ idNot });
    //console.log(body);
    let requestURL =
      this.URL +
      Values.API_RESOURCES.EGO_NOTIFICATIONS +
      this.reqPattern +
      Values.EGONOTIFICATIONS_REQS.DELETE_EGO_NOTIFICATION;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getQuestions() {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.REPORT +
      this.reqPattern +
      Values.REPORT_REQS.GET_QUESTIONS;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public loadOrphan() {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.ORPHAN +
      this.reqPattern +
      Values.ORPHAN_REQS.LOAD_OPHANS;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getCategoriasLanding(inmoId: number) {
    let body = JSON.stringify({ inmoId });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.LANDING +
      this.reqPattern +
      Values.LANDING_REQS.GET_CATEGORIAS;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getPuntuacionInmo(inmoId: number) {
    let body = JSON.stringify({ inmoId });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.LANDING +
      this.reqPattern +
      Values.LANDING_REQS.GET_PUNTUACION_INMO;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getInfoInmo(inmoId: number) {
    let body = JSON.stringify({ inmoId });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.LANDING +
      this.reqPattern +
      Values.LANDING_REQS.GET_INFO_INMO;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getHomeInfo(posicion: number, inmo: number) {
    let body = JSON.stringify({ posicion, inmo });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.LANDING +
      this.reqPattern +
      Values.LANDING_REQS.GET_HOME_INFO;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getInmos(inmoId: number) {
    let body = JSON.stringify({ inmoId });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.LANDING +
      this.reqPattern +
      Values.LANDING_REQS.GET_INMOS;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getGruposOrderByPuntuation(loggedInmo: number, inmoId: number) {
    let body = JSON.stringify({ loggedInmo, inmoId });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.GET_GRUPOS_INMO;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getCamposModulo(inmoId: number, moduloId: number) {
    let body = JSON.stringify({ inmoId, moduloId });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.LANDING +
      this.reqPattern +
      Values.LANDING_REQS.GET_CAMPOS_MODULOS;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public updateValue(
    id: any,
    tabla: string,
    campo: string,
    valor: any,
    tipoDato: string
  ) {
    let body = JSON.stringify({ id, tabla, campo, valor, tipoDato });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.LANDING +
      this.reqPattern +
      Values.LANDING_REQS.UPDATE_VALUE;
    //console.log(body);
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getOptionsSelect(nombreBackend: string, idModulo: string) {
    let body = JSON.stringify({ nombreBackend, idModulo });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.LANDING +
      this.reqPattern +
      Values.LANDING_REQS.GET_OPTIONS;
    console.log(body);
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public newOrphanUser(location, bodyUser, espera, comercial) {
    let body = JSON.stringify({ location, bodyUser, espera, comercial });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.INMO +
      this.reqPattern +
      Values.INMO_REQS.NEW_ORPHAN;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public assignNewInmoToOrphanUser(
    bodyInmo,
    reportBody,
    user,
    languageInmo,
    profile,
    comercial
  ) {
    let body = JSON.stringify({
      bodyInmo,
      reportBody,
      user,
      languageInmo,
      profile,
      comercial,
    });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.INMO +
      this.reqPattern +
      Values.INMO_REQS.ASSIGN_INMO_ORPHAN_USER;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public lookingUser(user) {
    let body = JSON.stringify({ user });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.INMO +
      this.reqPattern +
      Values.INMO_REQS.LOOKING_USER;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getKnowledgeInfo() {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.LANDING +
      this.reqPattern +
      Values.LANDING_REQS.GET_KNOWLEDGE_INFO;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getInmoName(idInmo: number) {
    let body = JSON.stringify({ idInmo });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.LANDING +
      this.reqPattern +
      Values.LANDING_REQS.GET_NAME_INMO;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getInmoNameByUserId(userId: number) {
    let body = JSON.stringify({ userId });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.INMO +
      this.reqPattern +
      Values.INMO_REQS.GET_NAME_INMO_BY_USER_ID;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getScreenInfo(screenId) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.LANDING +
      this.reqPattern +
      Values.LANDING_REQS.GET_SCREEN_INFO;
    let body = JSON.stringify({ screenId });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public signUpInmoUser(idInmo, user) {
    let body = JSON.stringify({ idInmo, user });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.INMO +
      this.reqPattern +
      Values.INMO_REQS.SIGN_UP_INMO_USER;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public acceptUser(user, noti, perfil_tipo?) {
    let body = JSON.stringify({ user, noti, perfil_tipo });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.INMO +
      this.reqPattern +
      Values.INMO_REQS.ACCEPT_USER;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public rejectUser(user, noti) {
    let body = JSON.stringify({ user, noti });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.INMO +
      this.reqPattern +
      Values.INMO_REQS.REJECT_CANCEL_USER;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public queueEmail(email, id, buttonActionId, empresaId) {
    let body = JSON.stringify({ email, id, buttonActionId, empresaId });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.EVENTS +
      this.reqPattern +
      Values.EVENTS_REQS.QUEUE_EMAIL;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  // public createDynamicEgoNotification(idModulo, id, not, peticionInfoId) {
  public createDynamicEgoNotification(id, not, buttonActionId, empresaId) {
    let body = JSON.stringify({ id, not, buttonActionId, empresaId });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.EVENTS +
      this.reqPattern +
      Values.EVENTS_REQS.CREATE_DYNAMIC_EGO_NOTIFICATION;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getPendingActivities(empresaId, userId) {
    let body = JSON.stringify({ empresaId, userId });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.ACTIVITIES +
      this.reqPattern +
      Values.ACTIVITIES_REQS.GET_PENDING_ACTIVITIES;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public acceptContract(idInmo) {
    let body = JSON.stringify({ idInmo });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.REPORT +
      this.reqPattern +
      Values.REPORT_REQS.ACCEPT_CONTRACT;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public acceptPrivacity(idUser) {
    let body = JSON.stringify({ idUser });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.REPORT +
      this.reqPattern +
      Values.REPORT_REQS.ACCEPT_PRIVACITY;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public updateEgoNotificationFinalHour(idNot, esInteractuacion) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.EGO_NOTIFICATIONS +
      this.reqPattern +
      Values.EGONOTIFICATIONS_REQS.UPDATE_EGO_NOTIFICATION_FINAL_HOUR;
    const body = JSON.stringify({ idNot, esInteractuacion });
    //console.log(body);
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getEgoNotificationById(idNot) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.EGO_NOTIFICATIONS +
      this.reqPattern +
      Values.EGONOTIFICATIONS_REQS.GET_EGO_NOTIFICATION_BY_ID;
    const body = JSON.stringify({ idNot });
    //console.log(body);
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  // ************************* COMMUNITY ********************************************

  public getInmoUrlById(idInmo: number) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.GET_URL_BY_ID_INMO;
    const body = JSON.stringify({ idInmo });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getInmoByName(myInmoId: number, inmoName: string, idUser: number) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.GET_INMO_BY_NAME;
    const body = JSON.stringify({ myInmoId, inmoName, idUser });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public checkIfVisible(id: number) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      "check-if-visible";
    const body = JSON.stringify({ id });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getMLSByName(myInmoId: number, mlsName: string, idUser: number) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.GET_MLS_BY_NAME;
    const body = JSON.stringify({ myInmoId, mlsName, idUser });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getInmoByName2(myGroupId: number, inmoName: string, idUser: number) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.GET_INMO_BY_NAME_GROUP;
    const body = JSON.stringify({ myGroupId, inmoName, idUser });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getMLSByName2(myGroupId: number, mlsName: string, idUser: number) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.GET_MLS_BY_NAME_GROUP;
    const body = JSON.stringify({ myGroupId, mlsName, idUser });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getViviendasByInmoName(inmoName: string) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.GET_VIVIENDAS;
    const body = JSON.stringify({ inmoName });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getViviendasOfGroup(inmoList: string) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.GET_VIVIENDAS_GROUP;
    const body = JSON.stringify({ inmoList });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public geInmosByMlsName(mlsName: string, inmoId: number) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.GET_INMOS;
    const body = JSON.stringify({ mlsName, inmoId });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public geInmosByMlsName2(mlsName: string, groupId: number) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.GET_INMOS_GROUP;
    const body = JSON.stringify({ mlsName, groupId });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getAllInmosAndMLS(id: number, type: number, idUsuario: number) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.GET_ALL;
    const body = JSON.stringify({ id, type, idUsuario });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getTodo(id: number, type: number, estado: number, idUsuario: number) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.GET_TODO;
    const body = JSON.stringify({ id, type, estado, idUsuario });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getBuscarColaboradores(
    id: number,
    type: number,
    estado: number,
    idUsuario: number
  ) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.GET_BUSCAR_COLABORADORES;
    const body = JSON.stringify({ id, type, estado, idUsuario });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getMisColaboradores(id: number, type: number, idUsuario: number) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.GET_MIS_COLABORADORES;
    const body = JSON.stringify({ id, type, idUsuario });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getSolicitudesPendientes(id: number, type: number, idUsuario: number) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.GET_SOLICITUDES_PENDIENTES;
    const body = JSON.stringify({ id, type, idUsuario });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getOpinions(inmoId: number) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.GET_OPINIONS;
    const body = JSON.stringify({ inmoId });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public solicitarColaboracion(
    idInmoSolicitante: number,
    idInmoSolicitada: number,
    idUsuario: number,
    estado: number,
    esPrivada: number
  ) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.SOLICITAR_COLABORACION;
    const body = JSON.stringify({
      idInmoSolicitante,
      idInmoSolicitada,
      idUsuario,
      estado,
      esPrivada,
    });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public actualizarColaboracion(colaborationId: number, estado: number) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.ACTUALIZAR_COLABORACION;
    const body = JSON.stringify({ colaborationId, estado });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public acceptCollaboration(user, noti) {
    console.log(noti);
    let body = JSON.stringify({ user, noti });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.ACCEPT_COLLABORATION;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public rejectCollaboration(user, noti) {
    let body = JSON.stringify({ user, noti });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.REJECT_COLLABORATION;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public acceptInmoGroupRequest(user, noti) {
    let body = JSON.stringify({ user, noti });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.ACCEPT_INMO_GROUP_REQUEST;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public rejectInmoGroupRequest(user, noti) {
    let body = JSON.stringify({ user, noti });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.REJECT_INMO_GROUP_REQUEST;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public acceptInmoGroupInvitation(user, noti) {
    let body = JSON.stringify({ user, noti });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.ACCEPT_INMO_GROUP_INVITATION;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public rejectInmoGroupInvitation(user, noti) {
    let body = JSON.stringify({ user, noti });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.REJECT_INMO_GROUP_INVITATION;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public acceptUserGroupRequest(user, noti) {
    let body = JSON.stringify({ user, noti });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.ACCEPT_USER_GROUP_REQUEST;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public rejectUserGroupRequest(user, noti) {
    let body = JSON.stringify({ user, noti });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.REJECT_USER_GROUP_REQUEST;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public acceptUserGroupInvitation(user, noti) {
    let body = JSON.stringify({ user, noti });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.ACCEPT_USER_GROUP_INVITATION;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public rejectUserGroupInvitation(user, noti) {
    let body = JSON.stringify({ user, noti });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.REJECT_USER_GROUP_INVITATION;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public inmoLeaveGroup(user, noti) {
    let body = JSON.stringify({ user, noti });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.INMO_LEAVE_GROUP;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public userLeaveGroup(user, noti) {
    let body = JSON.stringify({ user, noti });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.USER_LEAVE_GROUP;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public updateProfileType(tipoPerfil, idInmo) {
    let body = JSON.stringify({ tipoPerfil, idInmo });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.UPDATE_PROFILE_TYPE;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public updateProfileTypeGroup(tipoPerfil, idGroup) {
    let body = JSON.stringify({ tipoPerfil, idGroup });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.UPDATE_PROFILE_TYPE_GROUP;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public updateColaborarSegunMisAgrupaciones(colaboracionSeleccionada, idInmo) {
    let body = JSON.stringify({ colaboracionSeleccionada, idInmo });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.UPDATE_COLABORAR_SEGUN_MIS_AGRUPACIONES;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public updateColaborarSegunMisAgrupacionesPerson(grupos, bool) {
    let body = JSON.stringify({ grupos, bool });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.UPDATE_COLABORAR_SEGUN_MIS_AGRUPACIONES_PERSON;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public colaborarConBasic(basic, idInmo) {
    let body = JSON.stringify({ basic, idInmo });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.COLABORAR_CON_BASIC;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public colaborarConSilver(silver, idInmo) {
    let body = JSON.stringify({ silver, idInmo });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.COLABORAR_CON_SILVER;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public colaborarConGolden(golden, idInmo) {
    let body = JSON.stringify({ golden, idInmo });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.COLABORAR_CON_GOLDEN;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public colaborarConBasicGrupo(basic, idGroup) {
    let body = JSON.stringify({ basic, idGroup });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.COLABORAR_CON_BASIC_GRUPO;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public colaborarConSilverGrupo(silver, idGroup) {
    let body = JSON.stringify({ silver, idGroup });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.COLABORAR_CON_SILVER_GRUPO;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public colaborarConGoldenGrupo(golden, idGroup) {
    let body = JSON.stringify({ golden, idGroup });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.COLABORAR_CON_GOLDEN_GRUPO;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public updateFlatSharing(flatSharing, idInmo, listFS, listFL) {
    let body = JSON.stringify({ flatSharing, idInmo, listFS, listFL });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.UPDATE_FLATSHARING;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public updateFlatLending(flatLending, idInmo, listFS, listFL) {
    let body = JSON.stringify({ flatLending, idInmo, listFS, listFL });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.UPDATE_FLATLENDING;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public updateRecibirMensajes(mensajes, idInmo) {
    let body = JSON.stringify({ mensajes, idInmo });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.UPDATE_RECIBIR_MENSAJES;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public updateRecibirMensajesGroup(mensajes, idGroup) {
    let body = JSON.stringify({ mensajes, idGroup });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.UPDATE_RECIBIR_MENSAJES_GROUP;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public updateVerInmosGroup(verInmos, idGroup) {
    let body = JSON.stringify({ verInmos, idGroup });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.UPDATE_VER_INMOS_GROUP;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public updateVerViviendasGroup(verViviendas, idGroup) {
    let body = JSON.stringify({ verViviendas, idGroup });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.UPDATE_VER_VIVIENDAS_GROUP;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getCommunityInfo(idInmo) {
    let body = JSON.stringify({ idInmo });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.GET_COMMUNITY_INFO;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getCommunityInfoGroup(idGroup) {
    let body = JSON.stringify({ idGroup });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.GET_COMMUNITY_INFO_GROUP;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public solicitarGrupo(
    idGrupo: number,
    idInmo: number,
    invitada: number,
    idUsuario: number,
    estado: number
  ) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.SOLICITAR_GRUPO;
    const body = JSON.stringify({
      idGrupo,
      idInmo,
      invitada,
      idUsuario,
      estado,
    });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public actualizarGrupo(colaborationId: number, estado: number) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.UPDATE_GRUPO;
    const body = JSON.stringify({ colaborationId, estado });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getChatContacts(idInmo, userToken) {
    let body = JSON.stringify({ idInmo, userToken });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.GET_CHAT_CONTACTS;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public uploadChatGroupPicture(formData, nameImage, idGrupo) {
    /*let requestURL = this.URL + Values.API_RESOURCES.COMMUNITY + this.reqPattern + Values.COMMUNITY_REQS.UPLOAD_CHAT_GROUP_PICTURE;
    const body = JSON.stringify({ nameImage, idGrupo });
    return this.http.post(requestURL, body).pipe(map(response => response));*/
    const headers = new HttpHeaders();
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.UPLOAD_CHAT_GROUP_PICTURE;
    requestURL += "&nameImage=" + nameImage;
    requestURL += "&idGrupo=" + idGrupo;
    //return this.http.post(requestURL, formData, { headers }).pipe(map(response => response));
    return this.http.post<any>(requestURL, formData, {
      reportProgress: true,
      observe: "events",
    });
  }

  public updateChatGroupPicture(formData, nameImage, idGrupo) {
    const headers = new HttpHeaders();

    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.UPLOAD_CHAT_GROUP_PICTURE;

    requestURL += "&nameImage=" + nameImage;
    requestURL += "&idGrupo=" + idGrupo;

    //return this.http.post(requestURL, formData, { headers }).pipe(map(response => response));

    return this.http.post<any>(requestURL, formData, {
      reportProgress: true,
      observe: "events",
    });

    //let requestURL = this.URL + Values.API_RESOURCES.INMO + this.reqPattern + Values.INMO_REQS.POST_AVATAR_IMAGE_URL;
    /*let requestURL = this.URL + Values.API_RESOURCES.COMMUNITY + this.reqPattern + Values.COMMUNITY_REQS.UPDATE_CHAT_GROUP_PICTURE;
    requestURL += '&nameImage=' + nameImage;
    requestURL += '&idGrupo=' + idGrupo;

    const headers = new HttpHeaders();

    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');
    //let options = new RequestOptions({ headers: headers });
    return this.http.post(requestURL, formData, { headers }).pipe(map(response => response));*/

    // return this.http.post(requestURL, formData, { headers }).pipe(map(response => response));

    //let requestURL = this.URL + Values.API_RESOURCES.COMMUNITY + this.reqPattern + Values.COMMUNITY_REQS.UPLOAD_CHAT_GROUP_PICTURE;

    //const body = JSON.stringify({ nameImage, idGrupo });

    // return this.http.post(requestURL, formData, { headers }).pipe(map(response => response));
    // return this.http.post(requestURL, body).pipe(map(response => response));

    /*return this.http.post<any>(requestURL, formData, {
      reportProgress: true,
      observe: 'events'
    });*/
    //const body = JSON.stringify({ nameImage, idGrupo });
    //return this.http.post(requestURL, body).pipe(map(response => response));
  }

  public insertNewRoomPrivate(roomId, creationDate, roomTypeId) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.INSERT_NEW_ROOM_PRIVATE;
    const body = JSON.stringify({ roomId, creationDate, roomTypeId });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public insertNewRoomGroup(
    roomId,
    creationDate,
    roomTypeId,
    groupName,
    groupDescription,
    groupType,
    onlyAdminCanChat,
    onlyAdminCanAdd,
    onlyAdminCanEditGroupInfo,
    groupPic
  ) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.INSERT_NEW_ROOM_GROUP;
    const body = JSON.stringify({
      roomId,
      creationDate,
      roomTypeId,
      groupName,
      groupDescription,
      groupType,
      onlyAdminCanChat,
      onlyAdminCanAdd,
      onlyAdminCanEditGroupInfo,
      groupPic,
    });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public insertNewRoomInmoGroup(roomId, creationDate, roomTypeId, inmoId) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.INSERT_NEW_ROOM_INMO_GROUP;
    const body = JSON.stringify({ roomId, creationDate, roomTypeId, inmoId });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public insertNewUserInRoom(roomId, userId) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.INSERT_NEW_USER_IN_ROOM;
    const body = JSON.stringify({ roomId, userId });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public insertNewMessageChat(
    messageToken,
    creationDate,
    messageType,
    userId,
    message,
    roomId
  ) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.INSERT_NEW_MESSAGE_CHAT;
    const body = JSON.stringify({
      messageToken,
      creationDate,
      messageType,
      userId,
      message,
      roomId,
    });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public insertMessagesChat(messages, roomId) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.INSERT_MESSAGES_CHAT;
    const body = JSON.stringify({ messages, roomId });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getNextRoomMessages(roomId, pageNumber, limitResults, offset) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.GET_NEXT_ROOM_MESSAGES;
    const body = JSON.stringify({ roomId, pageNumber, limitResults, offset });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public insertUserChat(userToken) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.INSERT_USER_CHAT;
    const body = JSON.stringify({ userToken });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getUserChatInfo(userToken) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.GET_USER_CHAT_INFO;
    const body = JSON.stringify({ userToken });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public messageReadByAllGroupMembers(groupId, messageId, groupUsers) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.MESSAGE_READ_BY_ALL_GROUP_MEMBERS;
    const body = JSON.stringify({ groupId, messageId, groupUsers });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public insertMessageChatGroupUsers(groupId, messageId) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.INSERT_MESSAGE_CHAT_GROUP_USERS;
    const body = JSON.stringify({ groupId, messageId });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public updateMessageChatGroupUser(groupId, messageId, userToken) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.UPDATE_MESSAGE_CHAT_GROUP_USER;
    const body = JSON.stringify({ groupId, messageId, userToken });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getUserRooms(userToken) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.GET_USER_ROOMS;
    const body = JSON.stringify({ userToken });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getRoomInfo(userToken) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.GET_ROOM_INFO;
    const body = JSON.stringify({ userToken });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getCommunityAdminsForChatInmoGroup(
    inmoSolicitadaId,
    tokenUsuarioSolicitante
  ) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.GET_COMMUNITY_ADMINS_FOR_CHAT_INMO_GROUP;
    const body = JSON.stringify({ inmoSolicitadaId, tokenUsuarioSolicitante });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public checkIfRoomInmoGroupExists(userToken, inmoId) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.CHECK_IF_ROOM_INMO_GROUP_EXISTS;
    const body = JSON.stringify({ userToken, inmoId });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public checkIfUserChatExists(userToken, myToken) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.CHECK_IF_USER_CHAT_EXISTS;
    const body = JSON.stringify({ userToken, myToken });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public loadUserRooms(userToken) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.LOAD_USER_ROOMS;
    const body = JSON.stringify({ userToken });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  // ********************************************************************************

  // ******************************** FOLLOW ****************************************

  public insertNewFollow(idUsuario: number, tipo: number, id: number) {
    const requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.INSERT_NEW_FOLLOW;
    const body = JSON.stringify({ idUsuario, tipo, id });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public deleteFollow(id) {
    const requestURL =
      this.URL +
      Values.API_RESOURCES.COMMUNITY +
      this.reqPattern +
      Values.COMMUNITY_REQS.DELETE_FOLLOW;
    const body = JSON.stringify({ id });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  // ********************************************************************************

  public checkVivienda(propertyId: number, inmoId: number, ask: number) {
    const requestURL =
      this.URL +
      Values.API_RESOURCES.PROPERTIES +
      this.reqPattern +
      "check-vivienda";
    const body = JSON.stringify({ propertyId, inmoId, ask });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public updateTipoColaboracion(idVivienda: number, tipo_colaboracion: number) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.PROPERTIES +
      this.reqPattern +
      "update-colaboracion";
    const body = JSON.stringify({ idVivienda, tipo_colaboracion });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public cancelInmoAccount(userId, inmoId, inactive) {
    let body = JSON.stringify({ userId, inmoId, inactive });

    let requestURL =
      this.URL +
      Values.API_RESOURCES.INMO +
      this.reqPattern +
      Values.INMO_REQS.CANCEL_INMO_ACCOUNT;

    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public cancelGroupAccount(userId, groupId, inactive) {
    let body = JSON.stringify({ userId, groupId, inactive });

    let requestURL =
      this.URL +
      Values.API_RESOURCES.GROUP +
      this.reqPattern +
      Values.GROUP_REQS.CANCEL_GROUP_ACCOUNT;

    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public adminCountInmo(inmoId) {
    console.log(inmoId);

    let body = JSON.stringify({ inmoId });

    let requestURL =
      this.URL +
      Values.API_RESOURCES.INMO +
      this.reqPattern +
      Values.INMO_REQS.COUNT_ADMIN_INMO;

    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getUserMovinAfiliate() {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.INMO +
      this.reqPattern +
      Values.INMO_REQS.GET_USER_MOVIN_AFILIATE;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  // Locations GeoName
  public getLocations(params: Array<string>, full: boolean) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.LOCATIONS +
      this.reqPattern +
      Values.LOCATION_REQS.GET_LOCATIONS;
    const body = JSON.stringify({ params, full });
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public userIsInGroup(groupId: number, userId: number) {
    let body = JSON.stringify({ groupId, userId });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.USER +
      this.reqPattern +
      Values.USER_REQS.USER_IS_IN_GROUP;
    return this.http
      .post<any[]>(requestURL, body)
      .pipe(map((response) => response));
  }

  public getLogrosData(id: number, bool: boolean) {
    let body = JSON.stringify({ id, bool });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMON +
      this.reqPattern +
      Values.COMMON_REQS.GET_LOGROS_DATA;
    return this.http
      .post<any[]>(requestURL, body)
      .pipe(map((response) => response));
  }

  // Portales
  public getPortals() {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.PORTAL +
      this.reqPattern +
      Values.PORTAL_REQS.GET_PORTALS;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getPortalsByInmoId(idInmo: number) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.PORTAL +
      this.reqPattern +
      Values.PORTAL_REQS.GET_PORTALS_BY_INMO_ID;
    requestURL += "&idInmo=" + idInmo;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getPortalsForNewProperty(idInmo: number) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.PORTAL +
      this.reqPattern +
      Values.PORTAL_REQS.GET_PORTALS_FOR_NEW_PROPERTY;
    requestURL += "&idInmo=" + idInmo;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getViviendasInmoByPortalId(idInmo: number, idPortal: number, $idUser) {
    let body = JSON.stringify({ idInmo, idPortal, $idUser });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.PORTAL +
      this.reqPattern +
      Values.PORTAL_REQS.GET_VIVIENDAS_INMO_BY_PORTAL_ID;
    return this.http
      .post<any[]>(requestURL, body)
      .pipe(map((response) => response));
  }

  public publicar_portales_viviendas(
    idInmo,
    portales: any,
    propertiesPortals: any,
    action = null
  ) {
    const portals = Array.isArray(portales) ? portales : [portales];
    let body = {};
    if (action != null) {
      body = JSON.stringify({ idInmo, portals, propertiesPortals });
    } else {
      body = JSON.stringify({ idInmo, portals, propertiesPortals, action });
    }
    console.log("vivienda", body);
    let requestURL =
      this.URL +
      Values.API_RESOURCES.EXPORTERS +
      this.reqPattern +
      Values.EXPORTERS.PUBLICAR_PORTALES_VIVIENDA;
    return this.http
      .post<any[]>(requestURL, body)
      .pipe(map((response) => response));
  }

  public getInmoPortal(idInmo: number, idPortal: number) {
    let body = JSON.stringify({ idInmo, idPortal });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.PORTAL +
      this.reqPattern +
      Values.PORTAL_REQS.GET_INMO_PORTAL;
    return this.http
      .post<any[]>(requestURL, body)
      .pipe(map((response) => response));
  }

  public addInmoPortal(idInmo: number, idPortal: number) {
    let body = JSON.stringify({ idInmo, idPortal });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.PORTAL +
      this.reqPattern +
      Values.PORTAL_REQS.ADD_INMO_PORTAL;
    return this.http
      .post<any[]>(requestURL, body)
      .pipe(map((response) => response));
  }

  public updateInmoFactory(idVivienda, idPortal) {
    let body = JSON.stringify({ idVivienda, idPortal });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.EXPORTERS +
      this.reqPattern +
      Values.EXPORTERS.UPDATE_INMOFACTORY;
    return this.http.post("requestURL", body).pipe(map((response) => response));
  }

  public unpublishInmoFactory(idVivienda, idPortal) {
    let body = JSON.stringify({ idVivienda, idPortal });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.EXPORTERS +
      this.reqPattern +
      Values.EXPORTERS.UNPUBLISH_INMOFACTORY;
    return this.http.post("requestURL", body).pipe(map((response) => response));
  }

  public getGruposGraphInformation(groupId) {
    let body = JSON.stringify({ groupId });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.GROUP +
      this.reqPattern +
      Values.GROUP_REQS.GET_GROUP_GRAPHS;
    //console.log("requestURL: ",requestURL);
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public publishProperty(idInmo, idProperty) {
    let body = JSON.stringify({ idInmo, idProperty });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.PROPERTIES +
      this.reqPattern +
      "publish-property";
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getAllUsersWithNoInmo() {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.USER +
      this.reqPattern +
      "get-all-users-no-inmo";
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getModuleForEgo() {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.REPORT +
      this.reqPattern +
      Values.REPORT_REQS.GET_MODULOS;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getJourneyPopupInfo() {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.REPORT +
      this.reqPattern +
      Values.REPORT_REQS.GET_JOURNEY_POPUP_INGO;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  //public editJourney(id, active, name, plant, campana, user, deletePlant){
  public editJourney(
    plantilla,
    id,
    active,
    name,
    campana,
    user,
    deletePlantilla
  ) {
    console.log("las plantillas");
    console.log(plantilla);

    let body = JSON.stringify({
      plantilla,
      id,
      active,
      name,
      campana,
      user,
      deletePlantilla,
    });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.REPORT +
      this.reqPattern +
      Values.REPORT_REQS.EDIT_JOURNEY;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getJourney(id) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.REPORT +
      this.reqPattern +
      Values.REPORT_REQS.GET_JOURNEY;
    requestURL += "&id=" + id;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getAllJourney() {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.REPORT +
      this.reqPattern +
      Values.REPORT_REQS.GET_ALL_JOURNEY;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getPlantillaEgoButtonApp(idProduct, userId) {
    let body = JSON.stringify({ idProduct, userId });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.MARKETPLACE +
      this.reqPattern +
      Values.MARKETPLACE_REQS.GET_PLANTILLA_EGO_BUTTON_APP;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public insertPlantillaEgoButtonAppGenericProduct(
    idProduct,
    userId,
    empresaId,
    $from
  ) {
    /* FROM --> 1: venta, 2: tutorial */
    let body = JSON.stringify({ idProduct, userId, empresaId, $from });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.MARKETPLACE +
      this.reqPattern +
      Values.MARKETPLACE_REQS.INSERT_PLANTILLA_EGO_BUTTON_APP_GENERIC_PRODUCT;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getIdPlantillaEgoButtonAppGenericProduct(idProduct, $from) {
    /* FROM --> 1: venta, 2: tutorial */
    let body = JSON.stringify({ idProduct, $from });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.MARKETPLACE +
      this.reqPattern +
      Values.MARKETPLACE_REQS.GET_ID_PLANTILLA_EGO_BUTTON_APP_GENERIC_PRODUCT;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public setDemoRealizada(userId, idProduct) {
    let body = JSON.stringify({ userId, idProduct });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.MARKETPLACE +
      this.reqPattern +
      Values.MARKETPLACE_REQS.INSERT_CONFIG_PRODUCT;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getDemosInfo(userId: number, productos: any) {
    let body = JSON.stringify({ userId, productos });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.MARKETPLACE +
      this.reqPattern +
      Values.MARKETPLACE_REQS.GET_DEMOS_INFO;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getCampana(id) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.REPORT +
      this.reqPattern +
      Values.REPORT_REQS.GET_CAMPANA;
    requestURL += "&id=" + id;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getCampanaPopupInfo() {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.REPORT +
      this.reqPattern +
      Values.REPORT_REQS.GET_CAMPANA_POPUP_INFO;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public editCampana(
    journey: any,
    id: number,
    active: boolean,
    name: string,
    user: number,
    deleteJourney: any
  ) {
    console.log("journey");
    console.log(journey);
    console.log("deletePlantilla");
    console.log(deleteJourney);

    let body = JSON.stringify({
      journey,
      id,
      active,
      name,
      user,
      deleteJourney,
    });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.REPORT +
      this.reqPattern +
      Values.REPORT_REQS.EDIT_CAMPANA;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getAllCampana() {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.REPORT +
      this.reqPattern +
      Values.REPORT_REQS.GET_ALL_CAMPANA;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public mailchimpBackend(name, email) {
    let body = JSON.stringify({ name, email });
    let requestOptions = this.getRequestOptions();
    let requestURL =
      this.URL +
      Values.API_RESOURCES.REPORT +
      this.reqPattern +
      Values.REPORT_REQS.MAILCHIMP;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getInternalRouteById(id) {
    let body = JSON.stringify({ id });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.GENERIC +
      this.reqPattern +
      Values.GENERIC_REQUEST.GET_ROUTE_BY_ID;

    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getStructure(data, params = null, paramsExternalWindow = false) {
    let paramControl = JSON.parse(localStorage.getItem("paramControl"));
    if (paramControl != null) params = paramControl;
    //let paramsExternalWindowB = {paramsExternalWindow: paramsExternalWindow};
    let body = JSON.stringify({ data, params, paramsExternalWindow });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.GENERIC +
      this.reqPattern +
      Values.GENERIC_REQUEST.RETRIEVE_STRUCTURE;

    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getDataSource(idQuery: any, params = null) {
    let body = JSON.stringify({ idQuery, params });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.GENERIC +
      this.reqPattern +
      Values.GENERIC_REQUEST.GET_DATA_BY_ID;

    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getSelectionOptions(data, idQuery) {
    let body = JSON.stringify({ data, idQuery });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.GENERIC +
      this.reqPattern +
      Values.GENERIC_REQUEST.GET_DATA_BY_ID;

    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public updateResults(elements, data, params) {
    let body = JSON.stringify({ elements, data, params });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.GENERIC +
      this.reqPattern +
      Values.GENERIC_REQUEST.UPDATE_RESULTS;

    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public fetchInputsValues(idQuery: number, params: any): any {
    let body = JSON.stringify({ idQuery, params });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.GENERIC +
      this.reqPattern +
      Values.GENERIC_REQUEST.GET_DATA_BY_ID;

    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public insertFormData(
    data,
    formFields: any,
    removed: any,
    imageUpload,
    params
  ): any {
    let formData: FormData = new FormData();
    formData.append(
      "fields",
      JSON.stringify({ data, formFields, removed, params })
    );
    if (imageUpload.length > 0) {
      console.log("ENtro");
      let files = [];
      let j = 0;
      for (let i in imageUpload) {
        if (imageUpload[i]["tmp_value"]) {
          imageUpload[i]["tmp_value"].forEach((t) => {
            formData.append(String(j), t);
            j++;
          });
        }
      }
    }
    formData.forEach((r) => console.log("FORMDATA: ", r));
    let headers = new HttpHeaders();
    headers.append("Content-Type", "multipart/form-data");
    headers.append("Accept", "application/json");
    //let body = JSON.stringify({data, formFields, removed});
    //console.log(body);
    let requestURL =
      this.URL +
      Values.API_RESOURCES.GENERIC +
      this.reqPattern +
      Values.GENERIC_REQUEST.INSERT_FORM_DATA;
    console.log(requestURL);

    return this.http
      .post(requestURL, formData, { headers })
      .pipe(map((response) => response));
  }

  public updateViviendaConfigPortalesMassive(idPortal, data) {
    let body = JSON.stringify({ idPortal, data });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.GENERIC +
      this.reqPattern +
      Values.GENERIC_REQUEST.UPDATE_VIVIENDA_CONFIG_PORTALES_MASSIVE;

    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public deleteData(formFields): any {
    let body = JSON.stringify({ formFields });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.GENERIC +
      this.reqPattern +
      Values.GENERIC_REQUEST.DELETE_DATA;

    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public parseLanguageTag(params: any): any {
    let body = JSON.stringify({ params });
    console.log(body);
    let requestURL =
      this.URL +
      Values.API_RESOURCES.GENERIC +
      this.reqPattern +
      Values.GENERIC_REQUEST.PARSE_LANGUAGE_TAG;

    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getAdminAreaByInmo(inmoId: number) {
    let body = JSON.stringify({ inmoId });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.COMMON +
      this.reqPattern +
      Values.COMMON_REQS.GET_ADMIN_AREA_BY_INMO;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public updateEmails(bodyInmoEmail) {
    let body = JSON.stringify({ bodyInmoEmail });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.EMAILINMO +
      this.reqPattern +
      Values.EMAIL_INMO_REQS.UPDATE_EMAILS;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getVoucherCodeDiscounts(
    voucherCode: string,
    idAdminArea: number,
    idCompanyType: number
  ) {
    let body = JSON.stringify({ voucherCode, idAdminArea, idCompanyType });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.MARKETPLACE +
      this.reqPattern +
      "get-voucher-code-discounts";
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public captureEmail(bodyInmoEmail) {
    let body = JSON.stringify({ bodyInmoEmail });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.EMAILINMO +
      this.reqPattern +
      Values.EMAIL_INMO_REQS.CAPTURE_EMAIL;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public validateEmail($email, $password) {
    let body = JSON.stringify({ $email, $password });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.EMAILINMO +
      this.reqPattern +
      Values.EMAIL_INMO_REQS.VALIDATE_EMAIL;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public selectFolderEmail(bodyInmoEmail) {
    let body = JSON.stringify({ bodyInmoEmail });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.EMAILINMO +
      this.reqPattern +
      Values.EMAIL_INMO_REQS.SELECT_FOLDER;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getIdiomas() {
    let body = "";
    let requestURL =
      this.URL + Values.API_RESOURCES.COMMON + this.reqPattern + "get-idiomas";
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public verifyGoogle(user) {
    let body = JSON.stringify({ user });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.GOOGLE +
      this.reqPattern +
      Values.GOOGLE_REQS.VERIFY_ACCOUNT;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public newEventCalendarGoogle(token, authCode) {
    let body = JSON.stringify({ token, authCode });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.GOOGLE +
      this.reqPattern +
      Values.GOOGLE_REQS.NEW_EVENT_CALENDAR_GOOGLE;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public saveTokenGoogle(code) {
    let body = JSON.stringify({ code });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.GOOGLE +
      this.reqPattern +
      Values.GOOGLE_REQS.SAVE_TOKEN;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getCalendarsGoogle(user) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.GOOGLE +
      this.reqPattern +
      Values.GOOGLE_REQS.GET_CALENDARS;
    requestURL += "&user=" + user;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public updateDefaultEmpresaCalendarioUsuario(
    idEmpresa,
    idUsuario,
    idCalendarioFrom
  ) {
    let body = JSON.stringify({ idEmpresa, idUsuario, idCalendarioFrom });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.USER +
      this.reqPattern +
      Values.USER_REQS.UPDATE_DEFAULT_EMPRESA_CALENDARIO_USUARIO;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public vincularGoogleCalendar(user, idEmpresa) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.GOOGLE +
      this.reqPattern +
      Values.GOOGLE_REQS.VINCULAR_GOOGLE_CALENDAR;
    let body = JSON.stringify({ user, idEmpresa });
    return this.http
      .post<any[]>(requestURL, body)
      .pipe(map((response) => response));
  }

  public setCalendarsGoogle(user, calendar) {
    let body = JSON.stringify({ user, calendar });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.GOOGLE +
      this.reqPattern +
      Values.GOOGLE_REQS.SET_CALENDARS_GOOGLE;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public unsetCalendarsGoogle(user) {
    let body = JSON.stringify({ user });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.GOOGLE +
      this.reqPattern +
      Values.GOOGLE_REQS.UNSET_ALL_CALENDARS;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public desvincularGoogleCalendar(user) {
    let body = JSON.stringify({ user });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.GOOGLE +
      this.reqPattern +
      Values.GOOGLE_REQS.DESVINCULAR_CALENDAR_GOOGLE;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public vincularGoogleGmail(bodyInmoEmail) {
    let body = JSON.stringify({ bodyInmoEmail });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.GOOGLE +
      this.reqPattern +
      Values.GOOGLE_REQS.VINCULAR_GOOGLE_GMAIL;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public desvincularGoogleGmail(id) {
    let body = JSON.stringify({ id });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.EMAILINMO +
      this.reqPattern +
      Values.EMAIL_INMO_REQS.DESVINCULAR_GOOGLE_GMAIL;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public desvincularMicrosoftMail(id) {
    let body = JSON.stringify({ id });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.MICROSOFT +
      this.reqPattern +
      Values.MICROSOFT_REQS.DESVINCULAR_MICROSOFT_MAIL;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public setCalendarsMicrosoft(user, calendar) {
    let body = JSON.stringify({ user, calendar });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.MICROSOFT +
      this.reqPattern +
      Values.MICROSOFT_REQS.SET_MICROSOFT_CALENDARS;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public vincularMicrosoftCalendar(user, idEmpresa) {
    let body = JSON.stringify({ user, idEmpresa });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.MICROSOFT +
      this.reqPattern +
      Values.MICROSOFT_REQS.VINCULAR_MICROSOFT_CALENDAR;

    return this.http
      .post<any[]>(requestURL, body)
      .pipe(map((response) => response));
  }

  public desvincularMicrosoftCalendar(id) {
    let body = JSON.stringify({ id });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.MICROSOFT +
      this.reqPattern +
      Values.MICROSOFT_REQS.DESVINCULAR_MICROSOFT_CALENDAR;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public unsetCalendarsMicrosoft(user) {
    let body = JSON.stringify({ user });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.MICROSOFT +
      this.reqPattern +
      Values.MICROSOFT_REQS.UNSET_ALL_CALENDARS;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getCalendarsMicrosoft(user) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.MICROSOFT +
      this.reqPattern +
      Values.MICROSOFT_REQS.GET_CALENDARS;
    requestURL += "&user=" + user;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public generateUserToken(userId) {
    const idPropertyParam = "&userId=";
    let requestURL =
      this.URL +
      Values.API_RESOURCES.USER +
      this.reqPattern +
      Values.USER_REQS.USER_GENERATE_TOKEN;
    requestURL += idPropertyParam + userId;
    return this.http.get(requestURL).pipe(map((response) => response));
  }

  public duplicateFunctionalAreaDB(data) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.GENERIC +
      this.reqPattern +
      "duplicate-functional-area-db";
    data = JSON.stringify({ data });
    return this.http.post(requestURL, data).pipe(map((response) => response));
  }

  public getTextInmueble(value, idLanguage, type) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.GENERIC +
      this.reqPattern +
      Values.GENERIC_REQUEST.GET_TEXT_INMUEBLE;
    let data = JSON.stringify({ value, idLanguage, type });
    return this.http.post(requestURL, data).pipe(map((response) => response));
  }

  public saveTextInmueble(value, idLanguage, type, valueInsert) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.GENERIC +
      this.reqPattern +
      Values.GENERIC_REQUEST.SAVE_TEXT_INMUEBLE;
    let data = JSON.stringify({ value, idLanguage, type, valueInsert });
    return this.http.post(requestURL, data).pipe(map((response) => response));
  }

  public getImagesProperty(idProperty) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.GENERIC +
      this.reqPattern +
      Values.GENERIC_REQUEST.GET_IMAGES_PROPERTY;
    let data = JSON.stringify({ idProperty });
    return this.http.post(requestURL, data).pipe(map((response) => response));
  }

  public updateImagesProperty(images: any) {
    let body = JSON.stringify({ images });
    let requestURL =
      this.URL +
      Values.API_RESOURCES.GENERIC +
      this.reqPattern +
      Values.GENERIC_REQUEST.UPDATE_IMAGES_PROPERTY;
    return this.http.post(requestURL, body).pipe(map((response) => response));
  }

  public getConditionsFromEvento(idEvento, idReporte) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.GENERIC +
      this.reqPattern +
      Values.GENERIC_REQUEST.GET_CONDITIONS_FROM_EVENTO;
    let data = JSON.stringify({ idEvento, idReporte });
    return this.http.post(requestURL, data).pipe(map((response) => response));
  }

  public getFieldsNameTable(tableName) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.GENERIC +
      this.reqPattern +
      Values.GENERIC_REQUEST.GET_FIELDS_NAME_TABLE;
    let data = JSON.stringify({ tableName });
    return this.http.post(requestURL, data).pipe(map((response) => response));
  }

  public getEventosTables() {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.GENERIC +
      this.reqPattern +
      Values.GENERIC_REQUEST.GET_EVENTOS_TABLES;
    let data = JSON.stringify({});
    return this.http.post(requestURL, data).pipe(map((response) => response));
  }

  public getOperatorsConditions() {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.GENERIC +
      this.reqPattern +
      Values.GENERIC_REQUEST.GET_OPERATORS_CONDITIONS;
    let data = JSON.stringify({});
    return this.http.post(requestURL, data).pipe(map((response) => response));
  }

  public getElementsPlantilla(idPlantilla, idEmpresa) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.GENERIC +
      this.reqPattern +
      Values.GENERIC_REQUEST.GET_ELEMENTS_PLANTILLA;
    let data = JSON.stringify({ idPlantilla, idEmpresa });
    return this.http.post(requestURL, data).pipe(map((response) => response));
  }

  public getElementsTipos() {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.GENERIC +
      this.reqPattern +
      Values.GENERIC_REQUEST.GET_ELEMENTS_TIPOS;
    let data = JSON.stringify({});
    return this.http.post(requestURL, data).pipe(map((response) => response));
  }

	/**
   * Get Elements Generic creator
   * @returns
   */
  public getElementsGenericCreator(dataAPI) {

    let requestURL = this.URL + Values.API_RESOURCES.GENERIC + this.reqPattern + Values.GENERIC_REQUEST.GET_ELEMENTS_GENERIC_CREATOR;
    let data = JSON.stringify({data: dataAPI});
    return this.http.post(requestURL, data).pipe(map(response => response));
  }public vincularTwitter(idUser, idEmpresa) {
    let requestURL = this.URL + Values.API_RESOURCES.SOCIAL_MEDIA_TWITTER + this.reqPattern + Values.SOCIAL_MEDIA_REQS.VINCULAR_TWITTER;
    let data = JSON.stringify({idUser, idEmpresa});
    return this.http.post(requestURL, data).pipe(map((response) => response));
	}

  public vincularInstagram(idUser, idEmpresa) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.SOCIAL_MEDIA_INSTAGRAM +
      this.reqPattern +
      Values.SOCIAL_MEDIA_REQS.VINCULAR_INSTAGRAM;
    let data = JSON.stringify({ idUser, idEmpresa });
    return this.http.post(requestURL, data).pipe(map((response) => response));
  }

  public vincularFacebook(idUser, idEmpresa) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.SOCIAL_MEDIA_FACEBOOK +
      this.reqPattern +
      Values.SOCIAL_MEDIA_REQS.VINCULAR_FACEBOOK;
    let data = JSON.stringify({ idUser, idEmpresa });
    return this.http.post(requestURL, data).pipe(map((response) => response));
  }

  public vincularLinkedin(idUser, idEmpresa) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.SOCIAL_MEDIA_LINKEDIN +
      this.reqPattern +
      Values.SOCIAL_MEDIA_REQS.VINCULAR_LINKEDIN;
    let data = JSON.stringify({ idUser, idEmpresa });
    return this.http.post(requestURL, data).pipe(map((response) => response));
  }

  public desvincularTwitter(idUser, idEmpresa) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.SOCIAL_MEDIA_TWITTER +
      this.reqPattern +
      Values.SOCIAL_MEDIA_REQS.DESVINCULAR_TWITTER;
    let data = JSON.stringify({ idUser, idEmpresa });
    return this.http.post(requestURL, data).pipe(map((response) => response));
  }

  public desvincularInstagram(idUser, idEmpresa) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.SOCIAL_MEDIA_INSTAGRAM +
      this.reqPattern +
      Values.SOCIAL_MEDIA_REQS.DESVINCULAR_INSTAGRAM;
    let data = JSON.stringify({ idUser, idEmpresa });
    return this.http.post(requestURL, data).pipe(map((response) => response));
  }

  public desvincularFacebook(idUser, idEmpresa) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.SOCIAL_MEDIA_FACEBOOK +
      this.reqPattern +
      Values.SOCIAL_MEDIA_REQS.DESVINCULAR_FACEBOOK;
    let data = JSON.stringify({ idUser, idEmpresa });
    return this.http.post(requestURL, data).pipe(map((response) => response));
  }

  public desvincularLinkedin(idUser, idEmpresa) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.SOCIAL_MEDIA_LINKEDIN +
      this.reqPattern +
      Values.SOCIAL_MEDIA_REQS.DESVINCULAR_LINKEDIN;
    let data = JSON.stringify({ idUser, idEmpresa });
    return this.http.post(requestURL, data).pipe(map((response) => response));
  }

  public duplicatePlantillaEmail(id, idCreator, idEmpresa, idNewPlantilla, nombre, descripcion) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.GENERIC +
      this.reqPattern +
      Values.GENERIC_REQUEST.DUPLICATE_PLANTILLAS_EMAIL;
    let data = JSON.stringify({ id, idCreator,idEmpresa, idNewPlantilla, nombre, descripcion });
    return this.http.post(requestURL, data).pipe(map((response) => response));
  }

  public duplicarInmueble(idInmueble) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.PROPERTIES +
      this.reqPattern +
      Values.PROPERTIES_REQS.DUPLICATE_PROPERTY;
    let data = JSON.stringify({ idInmueble });
    return this.http.post(requestURL, data).pipe(map((response) => response));
  }

  public getSocialMediaAccounts(idEmpresa, from) {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.SOCIAL_MEDIA +
      this.reqPattern +
      Values.SOCIAL_MEDIA_REQS.GET_SOCIAL_MEDIA_ACCOUNTS;
    let data = JSON.stringify({ idEmpresa, from });
    return this.http.post(requestURL, data).pipe(map((response) => response));
  }

  public updateGenericCreatorStructure(json) {
    console.log('type', typeof json)
    console.log('type', json)
    let requestURL =
      this.URL +
      Values.API_RESOURCES.GENERIC +
      this.reqPattern +
      Values.GENERIC_REQUEST.UPDATE_FA_CUSTOM;
      console.log('requestURL', requestURL);
      let data = this.stringify(json)
      // let data = JSON.stringify(json);
      console.log('data type', data);

    return this.http.post(requestURL, data).pipe(map((response) => response));
  }

  stringify(obj) {
    let cache = [];
    let str = JSON.stringify(obj, function(key, value) {
      if (typeof value === "object" && value !== null) {
        if (cache.indexOf(value) !== -1) {
          // Circular reference found, discard key
          return;
        }
        // Store value in our collection
        cache.push(value);
      }
      return value;
    });
    cache = null; // reset the cache
    return str;
  }

  public getChipsInfo() {
    let requestURL =
      this.URL +
      Values.API_RESOURCES.GENERIC +
      this.reqPattern +
      Values.GENERIC_REQUEST.GET_CHIPS_INFO;
    return this.http.get<any[]>(requestURL).pipe(map((response) => response));
  }

  public getJourneysCreator(idJourney, idCompany) {
    let data = JSON.stringify({ idJourney, idCompany });

    let requestURL =
      this.URL +
      Values.API_RESOURCES.GENERIC +
      this.reqPattern +
      Values.USER_REQS.GET_JOURNEYS_CREATOR;
      return this.http.post(requestURL, data).pipe(map((response) => response));
  }

}

export interface ResponseInterface {
  errorCode: number;
  errorMessage: string;
  response: any;
}
